// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DMSConnections.css - Premium Beautification */

/* --- Page Container & Global Depth --- */
.dms-connections-container {
    max-width: 1800px;
    margin: 0;
    padding: 0 0 4rem;
    position: relative;
    z-index: 1;
}

/* Subtle Data Grid Background Pattern */
.dms-connections-container::before {
    content: '';
    position: absolute;
    inset: -20px;
    background-image:
        linear-gradient(rgba(0, 0, 0, 0.02) 1px, transparent 1px),
        linear-gradient(90deg, rgba(0, 0, 0, 0.02) 1px, transparent 1px);
    background-size: 50px 50px;
    mask-image: radial-gradient(circle at center, black 0%, transparent 80%);
    pointer-events: none;
    z-index: -1;
}

html[data-theme="dark"] .dms-connections-container::before {
    background-image:
        linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
        linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
}

/* --- Header Section --- */
/* Header classes removed in favor of global dms-page-header in EnterpriseDMS.css */

/* --- Grid Layout --- */
.dms-connections-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
    gap: 2.5rem;
}

/* Header Actions & Stats Bar */
.header-actions-premium {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 1.5rem;
}

.stats-summary-bar {
    display: flex;
    align-items: center;
    background: var(--surface);
    backdrop-filter: var(--glass-blur);
    padding: 0.6rem;
    border-radius: 100px;
    border: var(--glass-border);
    box-shadow: var(--glass-shadow);
}

.stat-pill {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.4rem 1.25rem;
    border-radius: 100px;
    background: rgba(255, 255, 255, 0.03);
    box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.05), 0 2px 8px rgba(0, 0, 0, 0.05);
    transition: background 0.3s ease;
}

.stat-pill:hover {
    background: rgba(255, 255, 255, 0.06);
}

.stat-pill.verified {
    background: rgba(16, 185, 129, 0.05);
}

.stat-pill.failed {
    background: rgba(239, 68, 68, 0.05);
}

.stat-label {
    font-size: 0.65rem;
    font-weight: 600;
    text-transform: uppercase;
    color: var(--text-muted);
    letter-spacing: 0.08em;
}

.stat-count {
    font-size: 1rem;
    font-weight: 600;
    color: var(--text-main);
    font-family: 'Outfit', monospace;
}

.stat-divider {
    width: 1px;
    height: 18px;
    background: var(--card-border);
}

/* Premium Add Button */
.btn-add-nexus {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    background: var(--gradient-main);
    color: white;
    padding: 0.85rem 2.25rem;
    border-radius: 16px;
    font-weight: 600;
    font-size: 1rem;
    border: none;
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    box-shadow: 0 10px 30px rgba(99, 102, 241, 0.3);
}

.btn-add-nexus:hover {
    transform: translateY(-4px) scale(1.02);
    box-shadow: 0 20px 45px rgba(99, 102, 241, 0.4);
}

/* --- Premium Connection Card (Nexus Glass) --- */
.dms-conn-card {
    background: var(--card-bg);
    backdrop-filter: var(--glass-blur);
    border: var(--glass-border);
    border-radius: 28px;
    padding: 1.75rem;
    position: relative;
    opacity: 0;
    animation: dropInBlur 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
    transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    overflow: hidden;
    box-shadow: var(--glass-shadow);
}

@keyframes dropInBlur {
    from {
        opacity: 0;
        transform: translateY(15px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.dms-conn-card:hover {
    transform: translateY(-10px);
    background: var(--card-hover-bg);
    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.15);
}

/* Role Accents - Radiant Borders */
.dms-conn-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 5px;
    opacity: 0.8;
}

.dms-conn-card:has(.aws)::before {
    background: linear-gradient(to right, #FF9900, #FFC300);
}

.dms-conn-card:has(.gcp)::before {
    background: linear-gradient(to right, #4285F4, #34A853);
}

.dms-conn-card:has(.azure)::before {
    background: linear-gradient(to right, #0089D6, #00BCF2);
}

/* Top Badge Row */
.card-top-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.dms-conn-card {
    background: var(--card-bg);
    backdrop-filter: var(--glass-blur);
    border: var(--glass-border);
    border-radius: 28px;
    padding: 1.75rem;
    position: relative;
    opacity: 0;
    animation: dropInBlur 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
    transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.4s ease, border-color 0.4s ease, background 0.4s ease;
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    overflow: hidden;
    box-shadow: var(--glass-shadow), var(--glass-inner-glow);
}

.dms-conn-card:hover {
    transform: translateY(-4px);
    background: var(--card-hover-bg);
    border-color: rgba(99, 102, 241, 0.3);
    box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.15), var(--glass-shadow);
}

.dms-conn-card:hover:has(.aws) {
    border-color: rgba(255, 153, 0, 0.4) !important;
    box-shadow: 0 30px 60px -10px rgba(0, 0, 0, 0.4), 0 0 20px rgba(255, 153, 0, 0.2), var(--glass-inner-glow) !important;
}

.dms-conn-card:hover:has(.gcp) {
    border-color: rgba(66, 133, 244, 0.4) !important;
    box-shadow: 0 30px 60px -10px rgba(0, 0, 0, 0.4), 0 0 20px rgba(66, 133, 244, 0.2), var(--glass-inner-glow) !important;
}

.dms-conn-card:hover:has(.azure) {
    border-color: rgba(0, 137, 214, 0.4) !important;
    box-shadow: 0 30px 60px -10px rgba(0, 0, 0, 0.4), 0 0 20px rgba(0, 137, 214, 0.2), var(--glass-inner-glow) !important;
}

.dms-conn-card.failed {
    background: rgba(239, 68, 68, 0.02) !important;
    backdrop-filter: var(--glass-blur);
    border: 1.5px solid rgba(239, 68, 68, 0.3) !important;
    box-shadow: 0 15px 35px rgba(239, 68, 68, 0.04), var(--glass-shadow), var(--glass-inner-glow);
}

.dms-conn-card.success {
    background: rgba(16, 185, 129, 0.02) !important;
    backdrop-filter: var(--glass-blur);
    border: 1.5px solid rgba(16, 185, 129, 0.3) !important;
    box-shadow: 0 15px 35px rgba(16, 185, 129, 0.04), var(--glass-shadow), var(--glass-inner-glow);
}

.dms-conn-card.checking {
    background: rgba(99, 102, 241, 0.02) !important;
    backdrop-filter: var(--glass-blur);
    border: 1.5px solid rgba(99, 102, 241, 0.3) !important;
    box-shadow: 0 15px 35px rgba(99, 102, 241, 0.04), var(--glass-shadow), var(--glass-inner-glow);
}

/* Role Accents - Subtle Indicator */
.dms-conn-card.role-source::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 6px;
    background: #94A3B8;
    /* Muted as per reference */
    opacity: 0.3;
}

/* Top Badge Row */
.card-top-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 28px;
}

.role-badge-pill {
    padding: 0.25rem 0.85rem;
    background: rgba(168, 85, 247, 0.1);
    color: #6D28D9;
    font-size: 0.65rem;
    font-weight: 600;
    border-radius: 8px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
}

.connectivity-chips-group {
    display: flex;
    align-items: center;
    gap: 1.5rem;
}

.connectivity-label {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.7rem;
    font-weight: 500;
    color: var(--text-secondary);
    letter-spacing: 0.02em;
}

.status-badge-pill {
    padding: 0.25rem 0.6rem;
    border-radius: 100px;
    font-size: 0.65rem;
    font-weight: 600;
    letter-spacing: 0.05em;
}

.status-badge-pill.failed {
    background: rgba(220, 38, 38, 0.1);
    color: #DC2626;
    border: 1.5px solid rgba(220, 38, 38, 0.3);
}

.status-badge-pill.success {
    background: rgba(16, 185, 129, 0.1);
    color: #059669;
    border: 1.5px solid rgba(16, 185, 129, 0.3);
}

.status-badge-pill.unknown {
    background: rgba(148, 163, 184, 0.1);
    color: #64748B;
    border: 1.5px solid rgba(148, 163, 184, 0.3);
}

.status-badge-pill.checking {
    background: rgba(99, 102, 241, 0.1);
    color: #4F46E5;
    border: 1.5px solid rgba(99, 102, 241, 0.3);
    animation: pulse-soft 2s infinite;
}

@keyframes pulse-soft {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0.6;
    }

    100% {
        opacity: 1;
    }
}

/* Card Body Main */
.card-identity-header {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    position: relative;
    padding: 0.25rem 0;
    width: 100%;
}

.provider-avatar-glass {
    width: 60px;
    height: 60px;
    background: var(--surface-light);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
    flex-shrink: 0;
}

.title-stack-content {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    min-width: 0;
    /* Essential for flex shrinking */
}

.primary-title-row {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.primary-title-row h3 {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 500;
    color: var(--text-primary);
    letter-spacing: -0.01em;
}

.subtitle-detail {
    font-size: 0.85rem;
    font-weight: 500;
    color: var(--text-primary);
}

.region-pill-min {
    font-size: 0.65rem;
    font-weight: 500;
    color: var(--text-primary);
    background: rgba(0, 0, 0, 0.05);
    padding: 0.2rem 0.5rem;
    border-radius: 4px;
}

.dms-conn-card:hover .db-icon-outer {
    transform: rotate(-8deg) scale(1.1);
}

/* Premium Details Grid */
.details-grid-premium {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.25rem;
    background: rgba(255, 255, 255, 0.02);
    padding: 1.5rem;
    border-radius: 20px;
    border: 1px solid var(--border-glass);
}

.detail-item {
    display: flex;
    gap: 0.85rem;
    align-items: center;
}

.detail-icon {
    width: 32px;
    height: 32px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.04);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--text-muted);
    border: 1px solid var(--border-glass);
}

/* Actions Row Strip */
.actions-row-strip {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    padding: 0.5rem 0;
    border-top: 1px solid rgba(0, 0, 0, 0.03);
    border-bottom: 1px solid rgba(0, 0, 0, 0.03);
}

html[data-theme='dark'] .actions-row-strip {
    border-color: rgba(255, 255, 255, 0.05);
}

.btn-sq-action {
    flex: 1 1;
    height: 38px;
    padding: 0 0.5rem;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    border: 1px solid var(--border-color);
    background: var(--bg-button-secondary);
    color: var(--text-secondary);
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    font-size: 0.65rem;
    font-weight: 600;
    letter-spacing: 0.08em;
}

/* Specific Action Colors */
.btn-sq-action.test {
    background: rgba(99, 102, 241, 0.08);
    color: #4f46e5;
    border-color: rgba(99, 102, 241, 0.2);
}

.btn-sq-action.test:hover {
    background: rgba(79, 70, 229, 0.15);
    color: #4338ca;
    border-color: rgba(79, 70, 229, 0.3);
    box-shadow: 0 4px 12px rgba(79, 70, 229, 0.15);
    transform: translateY(-2px);
}

.btn-sq-action.edit {
    background: rgba(168, 85, 247, 0.08);
    color: #7c3aed;
    border-color: rgba(168, 85, 247, 0.2);
}

.btn-sq-action.edit:hover {
    background: rgba(124, 58, 237, 0.15);
    color: #6d28d9;
    border-color: rgba(124, 58, 237, 0.3);
    box-shadow: 0 4px 12px rgba(124, 58, 237, 0.15);
    transform: translateY(-2px);
}

.btn-sq-action.delete {
    background: rgba(239, 68, 68, 0.08);
    color: #dc2626;
    border-color: rgba(239, 68, 68, 0.2);
}

.btn-sq-action.delete:hover {
    background: rgba(220, 38, 38, 0.15);
    color: #b91c1c;
    border-color: rgba(220, 38, 38, 0.3);
    box-shadow: 0 4px 12px rgba(220, 38, 38, 0.15);
    transform: translateY(-2px);
}

/* Dark Mode Overrides for Action Buttons */
html[data-theme='dark'] .btn-sq-action.test {
    background: rgba(99, 102, 241, 0.15);
    color: #a5b4fc;
}

html[data-theme='dark'] .btn-sq-action.edit {
    background: rgba(168, 85, 247, 0.15);
    color: #c084fc;
}

html[data-theme='dark'] .btn-sq-action.delete {
    background: rgba(239, 68, 68, 0.15);
    color: #f87171;
}

html[data-theme='dark'] .btn-sq-action:hover {
    background: white;
    color: #0f172a;
    border-color: white;
}

/* Inner Data Slate - Organized & Presentable */
.inner-data-slate {
    background: rgba(0, 0, 0, 0.02);
    border-radius: 12px;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    border: 1px solid rgba(0, 0, 0, 0.05);
}

html[data-theme='dark'] .inner-data-slate {
    background: rgba(255, 255, 255, 0.03);
    border-color: rgba(255, 255, 255, 0.05);
}

.slate-item-box {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    padding: 0.65rem 0.75rem;
    background: var(--bg-card);
    border: 1px solid var(--border-glass);
    border-radius: 12px;
    transition: all 0.2s ease;
    min-width: 0;
}

.slate-item-box:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-soft);
    border-color: var(--primary-color);
}

.slate-item-box.full {
    width: 100%;
}

.slate-label-row {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.slate-item-icon {
    color: var(--text-muted);
    opacity: 0.8;
}

.slate-item-icon.secure {
    color: #10b981;
}

.slate-label {
    font-size: 0.72rem;
    font-weight: 800;
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: 0.12em;
    opacity: 0.9;
}

.slate-value {
    font-family: 'Outfit', 'Plus Jakarta Sans', sans-serif;
    font-size: 1.05rem;
    font-weight: 400;
    color: var(--text-secondary);
    word-break: break-all;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.secure-text {
    color: #059669 !important;
}

.slate-grid-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.75rem;
}

.slate-grid-row.tri {
    grid-template-columns: 1fr 1fr 1.2fr;
}

/* Footer Mini */
.card-footer-mini {
    display: flex;
    justify-content: flex-end;
    margin-top: -0.5rem;
}

.footer-meta-right {
    display: flex;
    align-items: center;
    gap: 0.4rem;
}

.provider-name-mini {
    font-size: 0.7rem;
    font-weight: 600;
    color: var(--text-muted);
}

.date-stamp-mini {
    font-size: 0.7rem;
    color: var(--text-muted);
}

/* Redundant tag removed */

/* --- Empty State --- */
.empty-state-card {
    grid-column: 1 / -1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 8rem 2rem;
    background: var(--bg-card);
    border: 2px dashed var(--border-glass);
    border-radius: 40px;
    text-align: center;
    gap: 2rem;
    animation: fadeIn 0.8s ease-out;
}

.empty-state-icon {
    width: 120px;
    height: 120px;
    background: linear-gradient(135deg, rgba(124, 58, 237, 0.1) 0%, rgba(219, 39, 119, 0.1) 100%);
    border-radius: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--text-accent);
    border: 1px solid var(--border-glass);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
    transform: rotate(-10deg);
}

.empty-state-card h3 {
    font-size: 2rem;
    font-weight: 600;
    margin: 0;
    color: var(--text-primary);
}

.empty-state-card p {
    color: var(--text-muted);
    font-size: 1.15rem;
    max-width: 450px;
    line-height: 1.6;
}

/* --- Animations --- */
.spin-smooth {
    animation: spin 1.5s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.pulse-ring {
    animation: pulse-ring 2s infinite;
}

@keyframes pulse-ring {
    0% {
        transform: scale(0.95);
        opacity: 0.5;
    }

    50% {
        transform: scale(1.05);
        opacity: 1;
    }

    100% {
        transform: scale(0.95);
        opacity: 0.5;
    }
}

/* --- Dark Mode Precision Overrides (Data Slate V3) --- */
html[data-theme='dark'] .dms-conn-card {
    background: var(--card-bg);
    backdrop-filter: var(--glass-blur);
    border: var(--glass-border);
    box-shadow: var(--glass-shadow), var(--glass-inner-glow);
}

html[data-theme='dark'] .dms-conn-card.failed {
    background: rgba(239, 68, 68, 0.04) !important;
    backdrop-filter: var(--glass-blur);
    border: 1.5px solid rgba(239, 68, 68, 0.35) !important;
    box-shadow: 0 15px 35px rgba(239, 68, 68, 0.08), var(--glass-shadow), var(--glass-inner-glow);
}

html[data-theme='dark'] .dms-conn-card.success {
    background: rgba(16, 185, 129, 0.04) !important;
    backdrop-filter: var(--glass-blur);
    border: 1.5px solid rgba(16, 185, 129, 0.35) !important;
    box-shadow: 0 15px 35px rgba(16, 185, 129, 0.08), var(--glass-shadow), var(--glass-inner-glow);
}

html[data-theme='dark'] .primary-title-row h3 {
    color: var(--text-primary);
}

html[data-theme='dark'] .dms-conn-card.failed .primary-title-row h3,
html[data-theme='dark'] .dms-conn-card.failed .subtitle-detail {
    color: var(--text-primary);
}

html[data-theme='dark'] .inner-data-slate {
    background: rgba(15, 23, 42, 0.7);
    /* Translucent dark workspace */
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.05);
    box-shadow: inset 0 4px 12px rgba(0, 0, 0, 0.5);
}

html[data-theme='dark'] .slate-label {
    color: #94A3B8;
    /* Muted silver */
}

html[data-theme='dark'] .slate-value {
    color: #F8FAF8;
    /* Crisp white */
}

html[data-theme='dark'] .btn-sq-action {
    background: rgba(15, 23, 42, 0.8);
    border-color: rgba(255, 255, 255, 0.1);
    color: #CBD5E1;
}

html[data-theme='dark'] .btn-sq-action:hover {
    background: white;
    color: #0F172A;
}

html[data-theme='dark'] .btn-sq-action.delete {
    color: #f87171;
    /* Brighter red for dark mode */
    background: rgba(248, 113, 113, 0.08);
    border-color: rgba(248, 113, 113, 0.15);
}

html[data-theme='dark'] .btn-sq-action.delete:hover {
    background: #ef4444;
    color: white;
    border-color: #ef4444;
    box-shadow: 0 0 20px rgba(239, 68, 68, 0.4);
}

html[data-theme='dark'] .role-badge-pill {
    background: rgba(139, 92, 246, 0.2);
    color: #A78BFA;
}

html[data-theme='dark'] .connectivity-label {
    color: #94A3B8;
}

html[data-theme='dark'] .provider-avatar-glass {
    background: rgba(30, 41, 59, 0.8);
    /* Deep slate for dark mode */
}

html[data-theme='dark'] .footer-meta-right {
    opacity: 0.6;
}

html[data-theme="light"] .dms-conn-card,
html[data-theme="light"] .connection-card {
    background: rgba(255, 255, 255, 0.75) !important;
    backdrop-filter: blur(24px) saturate(180%) !important;
    border: 1.5px solid transparent !important;
    background-clip: padding-box !important;
    border-radius: 24px !important;
    position: relative !important;
    z-index: 1 !important;
    box-shadow:
        0 12px 30px rgba(0, 0, 0, 0.04),
        0 4px 10px rgba(0, 0, 0, 0.02),
        inset 0 1px 0 rgba(255, 255, 255, 0.6) !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

html[data-theme="dark"] .dms-conn-card,
html[data-theme="dark"] .connection-card {
    background: rgba(10, 15, 30, 0.85) !important;
    backdrop-filter: blur(24px) saturate(180%) !important;
    border: 1.5px solid transparent !important;
    background-clip: padding-box !important;
    border-radius: 24px !important;
    position: relative !important;
    z-index: 1 !important;
    box-shadow:
        0 20px 40px rgba(0, 0, 0, 0.18),
        0 8px 18px rgba(0, 0, 0, 0.08),
        inset 0 1px 0 rgba(255, 255, 255, 0.08) !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

/* Hover elevations */
.dms-conn-card:hover,
.connection-card:hover {
    transform: translateY(-4px) !important;
}

html[data-theme="light"] .dms-conn-card:hover,
html[data-theme="light"] .connection-card:hover {
    box-shadow:
        0 20px 40px rgba(0, 0, 0, 0.08),
        0 8px 16px rgba(0, 0, 0, 0.04),
        inset 0 1px 0 rgba(255, 255, 255, 0.7) !important;
}

html[data-theme="dark"] .dms-conn-card:hover,
html[data-theme="dark"] .connection-card:hover {
    box-shadow:
        0 30px 60px rgba(0, 0, 0, 0.25),
        0 12px 24px rgba(0, 0, 0, 0.12),
        inset 0 1px 0 rgba(255, 255, 255, 0.12) !important;
}

/* Card Gradient Border Pseudo Elements (For default non-tested state) */
.dms-conn-card::before,
.connection-card::before {
    content: '' !important;
    position: absolute !important;
    top: -2.5px !important;
    bottom: -2.5px !important;
    left: -2.5px !important;
    right: -2.5px !important;
    border-radius: 24px !important;
    z-index: -1 !important;
    pointer-events: none !important;
    padding: 2.5px !important;
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0) !important;
    mask-composite: exclude !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    opacity: 0.7 !important;
    background: transparent !important;
}

/* Disable card background glows to avoid flooding colors inside */
.dms-conn-card::after,
.connection-card::after {
    content: none !important;
    display: none !important;
}

/* Default border gradients for cloud providers */
.dms-conn-card.provider-gcp::before,
.connection-card.provider-gcp::before {
    background: linear-gradient(135deg, #06b6d4, #10b981) !important;
}

.dms-conn-card.provider-aws::before,
.connection-card.provider-aws::before {
    background: linear-gradient(135deg, #ef4444, #ec4899) !important;
}

.dms-conn-card.provider-azure::before,
.connection-card.provider-azure::before {
    background: linear-gradient(135deg, #8b5cf6, #6366f1) !important;
}

/* --- Tested States overrides matching Photos --- */

/* Light Mode: tested state card surfaces and borders */
html[data-theme="light"] .dms-conn-card.success,
html[data-theme="light"] .connection-card.test-success {
    background: rgba(240, 253, 250, 0.85) !important;
    border: 2.5px solid rgba(16, 185, 129, 0.8) !important;
    box-shadow: 0 10px 25px rgba(16, 185, 129, 0.05) !important;
}

html[data-theme="light"] .dms-conn-card.failed,
html[data-theme="light"] .connection-card.test-failed {
    background: rgba(254, 242, 242, 0.85) !important;
    border: 2.5px solid rgba(239, 68, 68, 0.8) !important;
    box-shadow: 0 10px 25px rgba(239, 68, 68, 0.05) !important;
}

/* Dark Mode: tested state card surfaces and solid borders */
html[data-theme="dark"] .dms-conn-card.success,
html[data-theme="dark"] .connection-card.test-success {
    background: rgba(10, 15, 30, 0.9) !important;
    border: 2.5px solid #10b981 !important;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.18), 0 0 15px rgba(16, 185, 129, 0.15) !important;
}

html[data-theme="dark"] .dms-conn-card.failed,
html[data-theme="dark"] .connection-card.test-failed {
    background: rgba(10, 15, 30, 0.9) !important;
    border: 2.5px solid #ef4444 !important;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.18), 0 0 15px rgba(239, 68, 68, 0.12) !important;
}

/* Hover border illumination */
.dms-conn-card:hover::before,
.connection-card:hover::before {
    opacity: 1.0 !important;
}

/* Provider Circular Logo containers */
.provider-avatar-glass {
    border-radius: 50% !important;
    width: 48px !important;
    height: 48px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    transition: all 0.3s ease !important;
}

html[data-theme="dark"] .provider-avatar-glass {
    background: #0d1119 !important;
    border: 1px solid rgba(255, 255, 255, 0.08) !important;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3) !important;
}

html[data-theme="light"] .provider-avatar-glass {
    background: #ffffff !important;
    border: 1px solid rgba(0, 0, 0, 0.08) !important;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05) !important;
}

/* Role Destination/Source badges */
.role-badge-pill {
    border-radius: 6px !important;
    font-size: 0.65rem !important;
    font-weight: 700 !important;
    padding: 0.2rem 0.6rem !important;
    letter-spacing: 0.05em !important;
}

/* Source - Purple */
.role-badge-pill.source {
    background: rgba(139, 92, 246, 0.15) !important;
    color: #c084fc !important;
    border: 1px solid rgba(139, 92, 246, 0.3) !important;
}

html[data-theme="light"] .role-badge-pill.source {
    background: rgba(139, 92, 246, 0.1) !important;
    color: #7c3aed !important;
    border: 1px solid rgba(139, 92, 246, 0.2) !important;
}

/* Destination - Cyan */
.role-badge-pill.destination {
    background: rgba(14, 165, 233, 0.15) !important;
    color: #38bdf8 !important;
    border: 1px solid rgba(14, 165, 233, 0.3) !important;
}

html[data-theme="light"] .role-badge-pill.destination {
    background: rgba(14, 165, 233, 0.1) !important;
    color: #0284c7 !important;
    border: 1px solid rgba(14, 165, 233, 0.2) !important;
}

/* ASIA-SOUTH1 region badge */
.region-pill-min {
    background: rgba(255, 255, 255, 0.06) !important;
    border: 1px solid rgba(255, 255, 255, 0.08) !important;
    color: #cbd5e1 !important;
    font-weight: 700 !important;
    font-size: 0.6rem !important;
    padding: 0.15rem 0.5rem !important;
    border-radius: 4px !important;
    letter-spacing: 0.04em !important;
}

html[data-theme="light"] .region-pill-min {
    background: rgba(0, 0, 0, 0.05) !important;
    border: 1px solid rgba(0, 0, 0, 0.08) !important;
    color: #4a5568 !important;
}

/* Glassy Inner Slates */
html[data-theme='dark'] .inner-data-slate,
html[data-theme='dark'] .connection-details {
    background: #090c15 !important;
    border: 1px solid rgba(255, 255, 255, 0.06) !important;
    border-radius: 16px !important;
    box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.35) !important;
}

html[data-theme='dark'] .slate-item-box,
html[data-theme='dark'] .detail-row {
    background: rgba(255, 255, 255, 0.03) !important;
    border: 1px solid rgba(255, 255, 255, 0.05) !important;
    border-radius: 12px !important;
    box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.02) !important;
}

html[data-theme='dark'] .slate-item-box:hover {
    background: rgba(255, 255, 255, 0.06) !important;
    border-color: rgba(255, 255, 255, 0.08) !important;
}

/* Light Mode: Inner slates tinted by test state */
html[data-theme='light'] .inner-data-slate,
html[data-theme='light'] .connection-details {
    background: rgba(0, 0, 0, 0.02) !important;
    border: 1px solid rgba(0, 0, 0, 0.04) !important;
    border-radius: 16px !important;
    box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.02) !important;
}

html[data-theme='light'] .dms-conn-card.success .inner-data-slate,
html[data-theme='light'] .connection-card.test-success .connection-details {
    background: rgba(209, 250, 229, 0.5) !important;
    border: 1px solid rgba(16, 185, 129, 0.15) !important;
}

html[data-theme='light'] .dms-conn-card.failed .inner-data-slate,
html[data-theme='light'] .connection-card.test-failed .connection-details {
    background: rgba(254, 226, 226, 0.6) !important;
    border: 1px solid rgba(239, 68, 68, 0.15) !important;
}

html[data-theme='light'] .slate-item-box,
html[data-theme='light'] .detail-row {
    background: #ffffff !important;
    border: 1px solid rgba(0, 0, 0, 0.06) !important;
    border-radius: 12px !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02) !important;
}

html[data-theme='light'] .slate-item-box:hover {
    background: #ffffff !important;
    border-color: rgba(99, 102, 241, 0.25) !important;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.04) !important;
}

/* Glass Buttons Base */
.btn-sq-action,
.btn-test,
.btn-edit-small,
.btn-delete-small {
    background: rgba(255, 255, 255, 0.02) !important;
    backdrop-filter: blur(8px) !important;
    border-radius: 10px !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    font-weight: 700 !important;
    font-size: 0.68rem !important;
    letter-spacing: 0.08em !important;
    text-transform: uppercase !important;
    box-shadow: none !important;
}

/* Light Mode Buttons */
html[data-theme="light"] .btn-sq-action.test,
html[data-theme="light"] .btn-test {
    background: rgba(99, 102, 241, 0.04) !important;
    border: 1px solid rgba(99, 102, 241, 0.35) !important;
    color: #4f46e5 !important;
}

html[data-theme="light"] .btn-sq-action.test:hover,
html[data-theme="light"] .btn-test:hover {
    background: rgba(99, 102, 241, 0.1) !important;
    border-color: #4f46e5 !important;
    transform: translateY(-2px) !important;
}

html[data-theme="light"] .btn-sq-action.edit,
html[data-theme="light"] .btn-edit-small {
    background: rgba(139, 92, 246, 0.04) !important;
    border: 1px solid rgba(139, 92, 246, 0.35) !important;
    color: #7c3aed !important;
}

html[data-theme="light"] .btn-sq-action.edit:hover,
html[data-theme="light"] .btn-edit-small:hover {
    background: rgba(139, 92, 246, 0.1) !important;
    border-color: #7c3aed !important;
    transform: translateY(-2px) !important;
}

html[data-theme="light"] .btn-sq-action.delete,
html[data-theme="light"] .btn-delete-small {
    background: rgba(239, 68, 68, 0.03) !important;
    border: 1px solid rgba(239, 68, 68, 0.35) !important;
    color: #dc2626 !important;
}

html[data-theme="light"] .btn-sq-action.delete:hover,
html[data-theme="light"] .btn-delete-small:hover {
    background: rgba(239, 68, 68, 0.08) !important;
    border-color: #dc2626 !important;
    transform: translateY(-2px) !important;
}

/* Dark Mode Buttons (Match white text/purple border layout from photo) */
html[data-theme="dark"] .btn-sq-action.test,
html[data-theme="dark"] .btn-test {
    background: rgba(99, 102, 241, 0.04) !important;
    border: 1px solid rgba(99, 102, 241, 0.45) !important;
    color: #ffffff !important;
}

html[data-theme="dark"] .btn-sq-action.test:hover,
html[data-theme="dark"] .btn-test:hover {
    background: rgba(99, 102, 241, 0.15) !important;
    border-color: #818cf8 !important;
    transform: translateY(-2px) !important;
}

html[data-theme="dark"] .btn-sq-action.edit,
html[data-theme="dark"] .btn-edit-small {
    background: rgba(139, 92, 246, 0.04) !important;
    border: 1px solid rgba(139, 92, 246, 0.45) !important;
    color: #ffffff !important;
}

html[data-theme="dark"] .btn-sq-action.edit:hover,
html[data-theme="dark"] .btn-edit-small:hover {
    background: rgba(139, 92, 246, 0.15) !important;
    border-color: #a78bfa !important;
    transform: translateY(-2px) !important;
}

html[data-theme="dark"] .btn-sq-action.delete,
html[data-theme="dark"] .btn-delete-small {
    background: rgba(239, 68, 68, 0.04) !important;
    border: 1px solid rgba(239, 68, 68, 0.45) !important;
    color: #fca5a5 !important;
}

html[data-theme="dark"] .btn-sq-action.delete:hover,
html[data-theme="dark"] .btn-delete-small:hover {
    background: rgba(239, 68, 68, 0.15) !important;
    border-color: #fda4af !important;
    transform: translateY(-2px) !important;
}

/* Badges - Outline-only glass pills */
.status-badge-pill,
.connectivity-label {
    border-radius: 100px !important;
    font-weight: 700 !important;
    font-size: 0.65rem !important;
    letter-spacing: 0.08em !important;
    text-transform: uppercase !important;
    padding: 0.25rem 0.65rem !important;
    background: transparent !important;
    box-shadow: none !important;
}

/* Light Mode Badges (Outline Only) */
html[data-theme="light"] .status-badge-pill.success {
    border: 1.5px solid rgba(16, 185, 129, 0.6) !important;
    color: #059669 !important;
}

html[data-theme="light"] .status-badge-pill.failed {
    border: 1.5px solid rgba(239, 68, 68, 0.5) !important;
    color: #dc2626 !important;
}

/* Dark Mode Badges (Outline Only) */
html[data-theme="dark"] .status-badge-pill.success {
    border: 1px solid rgba(16, 185, 129, 0.6) !important;
    color: #34d399 !important;
}

html[data-theme="dark"] .status-badge-pill.failed {
    border: 1px solid rgba(239, 68, 68, 0.6) !important;
    color: #fb7185 !important;
}

/* Neutral/Role tags & labels */
html[data-theme="light"] .connectivity-label {
    background: transparent !important;
    border: none !important;
    color: #52526b !important;
}

html[data-theme="dark"] .connectivity-label {
    background: transparent !important;
    border: none !important;
    color: #cbd5e1 !important;
}

/* Typography readability and contrast overrides */
html[data-theme="light"] .primary-title-row h3 {
    color: #090d16 !important;
    font-weight: 700 !important;
}

html[data-theme="light"] .subtitle-detail {
    color: #52526b !important;
    font-weight: 500 !important;
}

html[data-theme="light"] .slate-label,
html[data-theme="light"] .detail-label {
    color: #000 !important;
    font-weight: 800 !important;
}

html[data-theme="light"] .slate-value,
html[data-theme="light"] .detail-value {
    color: #0f172a !important;
    font-weight: 400 !important;
}

html[data-theme="light"] .secure-text {
    color: #059669 !important;
    font-weight: 600 !important;
}

html[data-theme="dark"] .primary-title-row h3 {
    color: #ffffff !important;
    font-weight: 700 !important;
}

html[data-theme="dark"] .subtitle-detail {
    color: #cbd5e1 !important;
    font-weight: 500 !important;
}

html[data-theme="dark"] .slate-label,
html[data-theme="dark"] .detail-label {
    color: #e2e8f0 !important;
    font-weight: 800 !important;
}

html[data-theme="dark"] .slate-value,
html[data-theme="dark"] .detail-value {
    color: #ffffff !important;
    font-weight: 400 !important;
}

/* --- Draft Connection Card and Status Badge Styling --- */
html[data-theme="light"] .dms-conn-card.draft,
html[data-theme="light"] .connection-card.draft {
    background: rgba(254, 243, 199, 0.75) !important;
    border: 2.5px solid rgba(245, 158, 11, 0.8) !important;
    box-shadow: 0 10px 25px rgba(245, 158, 11, 0.05) !important;
}

html[data-theme="dark"] .dms-conn-card.draft,
html[data-theme="dark"] .connection-card.draft {
    background: rgba(10, 15, 30, 0.9) !important;
    border: 2.5px solid #fbbf24 !important;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.18), 0 0 15px rgba(245, 158, 11, 0.15) !important;
}

html[data-theme="light"] .status-badge-pill.draft {
    border: 1.5px solid rgba(245, 158, 11, 0.6) !important;
    color: #d97706 !important;
    background: transparent !important;
}

html[data-theme="dark"] .status-badge-pill.draft {
    border: 1px solid rgba(251, 191, 36, 0.6) !important;
    color: #fbbf24 !important;
    background: transparent !important;
}

html[data-theme='light'] .dms-conn-card.draft .inner-data-slate,
html[data-theme='light'] .connection-card.draft .connection-details {
    background: rgba(254, 243, 199, 0.4) !important;
    border: 1px solid rgba(245, 158, 11, 0.15) !important;
}

/* ==========================================================================
   TOOLBAR SECTION (Search, Filter, Sort)
   ========================================================================== */

.connections-toolbar-premium {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 0.75rem;
    /* 12px gaps between controls */
    margin-bottom: 2.5rem;
    padding: 0.5rem 0.5rem;
    width: 100%;
}

@media (max-width: 768px) {
    .connections-toolbar-premium {
        flex-direction: column;
        align-items: stretch;
        gap: 1rem;
    }

    .view-switcher-premium {
        width: 100%;
    }

    .btn-switcher-tab {
        flex: 1 1;
    }
}

/* --- Search Bar Glass Container --- */
.search-bar-glass-container {
    position: relative;
    flex: 1 1;
    display: flex;
    align-items: center;
    max-width: none;
    background: var(--bg-input, rgba(10, 12, 24, 0.45));
    backdrop-filter: blur(20px);
    border: 1px solid var(--border-glass, rgba(255, 255, 255, 0.08));
    border-radius: 12px;
    padding: 0 0.85rem;
    height: 42px;
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);
    transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

html[data-theme='light'] .search-bar-glass-container {
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.08);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.02), 0 4px 15px rgba(0, 0, 0, 0.02);
}

.search-icon-dim {
    color: var(--text-muted);
    margin-right: 0.75rem;
    pointer-events: none;
    transition: color 0.28s;
}

input[type="text"].search-input-glass {
    flex: 1 1;
    border: none !important;
    background: transparent !important;
    color: var(--text-primary) !important;
    font-size: 0.9rem !important;
    font-weight: 500 !important;
    outline: none !important;
    padding: 0 !important;
    height: 100% !important;
    box-shadow: none !important;
    border-radius: 0 !important;
}

.search-input-glass::placeholder {
    color: var(--text-muted);
    opacity: 0.7;
}

.clear-search-btn {
    border: none;
    background: transparent;
    color: var(--text-muted);
    font-size: 1.2rem;
    cursor: pointer;
    padding: 0 4px;
    transition: color 0.2s;
    line-height: 1;
    display: flex;
    align-items: center;
}

.clear-search-btn:hover {
    color: var(--text-primary);
}

/* Focus State: Soft Purple Glow */
.search-bar-glass-container:focus-within {
    border-color: rgba(168, 85, 247, 0.5) !important;
    box-shadow: 0 0 0 1px rgba(168, 85, 247, 0.2), 0 0 15px rgba(168, 85, 247, 0.15), inset 0 1px 1px rgba(255, 255, 255, 0.05);
}

html[data-theme='light'] .search-bar-glass-container:focus-within {
    border-color: rgba(168, 85, 247, 0.6) !important;
    box-shadow: 0 0 0 1px rgba(168, 85, 247, 0.2), 0 0 12px rgba(168, 85, 247, 0.12);
}

/* --- Dropdown controls --- */
.toolbar-actions-group {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

@media (max-width: 768px) {
    .toolbar-actions-group {
        justify-content: flex-start;
        width: 100%;
    }

    .toolbar-dropdown-container {
        flex: 1 1;
    }

    .btn-toolbar-dropdown {
        width: 100%;
        justify-content: space-between;
    }
}

.toolbar-dropdown-container {
    position: relative;
}

.btn-toolbar-dropdown {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    height: 42px;
    padding: 0 1.1rem;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.03);
    backdrop-filter: blur(16px);
    border: 1px solid rgba(255, 255, 255, 0.06);
    color: var(--text-secondary);
    font-size: 0.82rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
}

html[data-theme='light'] .btn-toolbar-dropdown {
    background: rgba(0, 0, 0, 0.01);
    border: 1px solid rgba(0, 0, 0, 0.06);
    color: #4b5563;
}

.btn-toolbar-dropdown:hover {
    background: rgba(255, 255, 255, 0.06);
    border-color: rgba(255, 255, 255, 0.12);
    color: var(--text-primary);
    transform: translateY(-1px);
}

html[data-theme='light'] .btn-toolbar-dropdown:hover {
    background: rgba(0, 0, 0, 0.03);
    border-color: rgba(0, 0, 0, 0.12);
    color: #111827;
}

.btn-toolbar-dropdown.active-filter {
    border-color: rgba(168, 85, 247, 0.4);
    background: rgba(168, 85, 247, 0.05);
    color: #a855f7;
}

html[data-theme='light'] .btn-toolbar-dropdown.active-filter {
    border-color: rgba(168, 85, 247, 0.5);
    background: rgba(168, 85, 247, 0.04);
    color: #7e22ce;
}

.chevron-rotate {
    transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

.chevron-rotate.open {
    transform: rotate(180deg);
}

/* Floating Glass Dropdown Panel */
.dropdown-panel-glass {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    width: 220px;
    background: rgba(15, 23, 42, 0.85);
    backdrop-filter: blur(24px) saturate(180%);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 14px;
    padding: 0.4rem;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.05);
    z-index: 1000;
    
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transform: translateY(-8px) scale(0.97);
    transition: opacity 0.2s, visibility 0.2s, transform 0.2s;
}

.dropdown-panel-glass.open {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
    animation: slideDownFade 0.2s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

html[data-theme='light'] .dropdown-panel-glass {
    background: rgba(255, 255, 255, 0.95);
    border: 1px solid rgba(0, 0, 0, 0.08);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
}

@keyframes slideDownFade {
    from {
        opacity: 0;
        transform: translateY(-8px) scale(0.97);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

.dropdown-panel-header {
    font-size: 0.65rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: var(--text-muted);
    padding: 0.4rem 0.75rem;
    margin-bottom: 0.25rem;
}

.dropdown-panel-options {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.dropdown-option-btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0.55rem 0.75rem;
    border-radius: 8px;
    border: none;
    background: transparent;
    color: var(--text-secondary);
    font-size: 0.82rem;
    font-weight: 550;
    text-align: left;
    cursor: pointer;
    transition: all 0.2s;
}

html[data-theme='light'] .dropdown-option-btn {
    color: #4b5563;
}

.dropdown-option-btn:hover {
    background: rgba(255, 255, 255, 0.06);
    color: var(--text-primary);
}

html[data-theme='light'] .dropdown-option-btn:hover {
    background: rgba(0, 0, 0, 0.03);
    color: #111827;
}

.dropdown-option-btn.selected {
    background: rgba(99, 102, 241, 0.08);
    color: #818cf8;
}

html[data-theme='light'] .dropdown-option-btn.selected {
    background: rgba(99, 102, 241, 0.05);
    color: #4f46e5;
}

.check-icon-purple {
    color: #818cf8;
}

html[data-theme='light'] .check-icon-purple {
    color: #4f46e5;
}

/* --- Empty state for search results --- */
.no-search-results-glass {
    grid-column: 1 / -1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 4rem 2rem;
    background: rgba(255, 255, 255, 0.01);
    backdrop-filter: blur(12px);
    border: 1px dashed var(--border-color);
    border-radius: 20px;
    text-align: center;
}

html[data-theme='light'] .no-search-results-glass {
    background: rgba(0, 0, 0, 0.005);
}

.no-results-icon {
    color: var(--text-muted);
    opacity: 0.4;
    margin-bottom: 1rem;
}

.no-search-results-glass h3 {
    margin: 0 0 0.5rem;
    font-size: 1.2rem;
    color: var(--text-primary);
}

.no-search-results-glass p {
    margin: 0 0 1.5rem;
    font-size: 0.88rem;
    color: var(--text-muted);
    max-width: 400px;
}

.btn-secondary-toolbar {
    padding: 0.6rem 1.25rem;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid var(--border-color);
    color: var(--text-primary);
    font-size: 0.8rem;
    font-weight: 600;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s;
}

html[data-theme='light'] .btn-secondary-toolbar {
    background: rgba(0, 0, 0, 0.01);
}

.btn-secondary-toolbar:hover {
    background: rgba(255, 255, 255, 0.08);
    transform: translateY(-1px);
}

html[data-theme='light'] .btn-secondary-toolbar:hover {
    background: rgba(0, 0, 0, 0.03);
}

/* ==========================================================================
   DRAFTS SECTION & DRAFT CARDS (Mini Glassmorphism Design)
   ========================================================================== */

.drafts-section-divider-container {
    margin-top: 5rem;
    padding-top: 3rem;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
}

/* --- View Switcher Segmented Control --- */
.view-switcher-premium {
    display: flex;
    align-items: center;
    height: 42px;
    background: rgba(255, 255, 255, 0.03);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 99px;
    /* Rounded pill container */
    padding: 3px;
    gap: 2px;
    box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.01), 0 4px 12px rgba(0, 0, 0, 0.05);
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

html[data-theme='light'] .view-switcher-premium {
    background: rgba(0, 0, 0, 0.015);
    border-color: rgba(0, 0, 0, 0.06);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.01), 0 2px 8px rgba(0, 0, 0, 0.02);
}

/* Subtle hover lift & shadow glow */
.view-switcher-premium:hover {
    transform: translateY(-1px);
    border-color: rgba(168, 85, 247, 0.2);
    box-shadow:
        0 6px 20px rgba(0, 0, 0, 0.15),
        0 0 10px rgba(168, 85, 247, 0.05),
        inset 0 1px 1px rgba(255, 255, 255, 0.02);
}

html[data-theme='light'] .view-switcher-premium:hover {
    border-color: rgba(124, 58, 237, 0.15);
    box-shadow: 0 4px 12px rgba(124, 58, 237, 0.04);
}

.btn-switcher-tab {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: 100%;
    padding: 0 1.5rem;
    border-radius: 99px;
    border: 1px solid transparent;
    background: transparent;
    color: var(--text-secondary);
    font-size: 0.85rem;
    font-weight: 600;
    cursor: pointer;
    opacity: 0.65;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    white-space: nowrap;
}

.btn-switcher-tab:hover {
    opacity: 1;
    color: var(--text-primary);
    background: rgba(255, 255, 255, 0.03);
}

html[data-theme='light'] .btn-switcher-tab:hover {
    background: rgba(0, 0, 0, 0.02);
}

/* Active Segment Highlight: glossy glassmorphism, LED border glow, elevated surface */
.btn-switcher-tab.active {
    opacity: 1;
    color: #ffffff !important;
    background: linear-gradient(135deg, rgba(168, 85, 247, 0.28) 0%, rgba(99, 102, 241, 0.24) 100%) !important;
    border: 1px solid rgba(168, 85, 247, 0.6) !important;
    box-shadow:
        0 0 12px rgba(168, 85, 247, 0.35),
        0 4px 10px rgba(0, 0, 0, 0.25),
        inset 0 1px 0 rgba(255, 255, 255, 0.12) !important;
}

html[data-theme='light'] .btn-switcher-tab.active {
    background: linear-gradient(135deg, rgba(124, 58, 237, 0.16) 0%, rgba(79, 70, 229, 0.16) 100%) !important;
    color: #6d28d9 !important;
    border: 1px solid rgba(124, 58, 237, 0.5) !important;
    box-shadow:
        0 0 10px rgba(124, 58, 237, 0.25),
        0 4px 8px rgba(124, 58, 237, 0.1),
        inset 0 1px 0 rgba(255, 255, 255, 0.2) !important;
}

/* Red/Green LED highlight when Drafts tab has drafts */
.btn-switcher-tab.has-drafts::after {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #10b981;
    box-shadow: 0 0 8px #10b981;
    display: inline-block;
    margin-left: 2px;
}

/* Transition Blur effect for main grid switching */
.dms-connections-grid {
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.dms-connections-grid.transition-blur {
    opacity: 0;
    filter: blur(8px);
    transform: scale(0.98);
}

/* Configuration Progress Bar in Draft Cards */
.draft-progress-container {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin: 0.8rem 0;
    padding: 0.5rem 0.25rem 0;
}

.draft-progress-label-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.72rem;
    font-weight: 600;
}

.draft-progress-text {
    color: var(--text-muted);
}

.draft-progress-percent {
    color: #a78bfa;
}

html[data-theme='light'] .draft-progress-percent {
    color: #6d28d9;
}

.draft-progress-track {
    height: 6px;
    border-radius: 100px;
    background: rgba(255, 255, 255, 0.04);
    overflow: hidden;
    position: relative;
    border: 1px solid rgba(255, 255, 255, 0.02);
}

html[data-theme='light'] .draft-progress-track {
    background: rgba(0, 0, 0, 0.04);
    border-color: rgba(0, 0, 0, 0.02);
}

.draft-progress-fill {
    height: 100%;
    border-radius: 100px;
    background: linear-gradient(90deg, #a78bfa, #818cf8);
    transition: width 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

html[data-theme='light'] .draft-progress-fill {
    background: linear-gradient(90deg, #7c3aed, #4f46e5);
}

/* ── Draft Connection Card ── */
.draft-conn-card {
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 1.35rem;
    border-radius: 24px;
    background: rgba(15, 20, 35, 0.72);
    border: 1.5px dashed rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(24px) saturate(160%);
    -webkit-backdrop-filter: blur(24px) saturate(160%);
    cursor: default;
    transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);
    opacity: 0;
    animation: draftCardIn 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
    overflow: hidden;
}

html[data-theme='light'] .draft-conn-card {
    background: rgba(248, 250, 255, 0.75);
    border: 1.5px dashed rgba(0, 0, 0, 0.1);
}

@keyframes draftCardIn {
    from {
        opacity: 0;
        transform: translateY(12px) scale(0.98);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

/* Hover state */
.draft-conn-card:hover {
    transform: translateY(-3px);
    border-color: rgba(168, 85, 247, 0.35);
    background: rgba(20, 27, 50, 0.85);
    box-shadow:
        0 12px 32px rgba(0, 0, 0, 0.3),
        0 0 0 1px rgba(168, 85, 247, 0.15),
        inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

html[data-theme='light'] .draft-conn-card:hover {
    background: rgba(255, 255, 255, 0.92);
    border-color: rgba(124, 58, 237, 0.3);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.07), 0 0 0 1px rgba(124, 58, 237, 0.12);
}

/* Glossy top edge light sweep */
.draft-conn-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg,
            transparent 0%,
            rgba(168, 85, 247, 0.4) 40%,
            rgba(99, 179, 237, 0.3) 60%,
            transparent 100%);
    opacity: 0;
    transition: opacity 0.3s ease;
}

.draft-conn-card:hover::before {
    opacity: 1;
}

/* Role-specific left glow */
.draft-conn-card.role-source:hover {
    box-shadow:
        0 12px 32px rgba(0, 0, 0, 0.3),
        -2px 0 14px rgba(168, 85, 247, 0.12),
        0 0 0 1px rgba(168, 85, 247, 0.2);
}

.draft-conn-card.role-destination:hover {
    box-shadow:
        0 12px 32px rgba(0, 0, 0, 0.3),
        -2px 0 14px rgba(56, 189, 248, 0.12),
        0 0 0 1px rgba(56, 189, 248, 0.2);
}

/* ── Draft Badges ── */
.draft-badges-group {
    display: flex;
    align-items: center;
    gap: 0.4rem;
}

.badge-auto-saved {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    height: 18px;
    padding: 0 7px;
    border-radius: 100px;
    background: rgba(251, 191, 36, 0.1);
    border: 1px solid rgba(251, 191, 36, 0.3);
    color: #fbbf24;
    font-size: 0.6rem;
    font-weight: 700;
    letter-spacing: 0.03em;
    text-transform: uppercase;
}

html[data-theme='light'] .badge-auto-saved {
    background: rgba(217, 119, 6, 0.08);
    border-color: rgba(217, 119, 6, 0.3);
    color: #b45309;
}

.badge-incomplete {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    height: 18px;
    padding: 0 7px;
    border-radius: 100px;
    background: rgba(239, 68, 68, 0.08);
    border: 1px solid rgba(239, 68, 68, 0.25);
    color: #f87171;
    font-size: 0.6rem;
    font-weight: 700;
    letter-spacing: 0.03em;
    text-transform: uppercase;
}

html[data-theme='light'] .badge-incomplete {
    background: rgba(220, 38, 38, 0.06);
    border-color: rgba(220, 38, 38, 0.2);
    color: #dc2626;
}

/* ── Draft avatar (dimmer than live connections) ── */
.draft-avatar {
    opacity: 0.7;
}

.draft-conn-card:hover .draft-avatar {
    opacity: 1;
}

/* Draft status tag */
.draft-status-tag {
    display: inline-flex;
    align-items: center;
    height: 16px;
    padding: 0 6px;
    border-radius: 4px;
    background: rgba(168, 85, 247, 0.1);
    border: 1px solid rgba(168, 85, 247, 0.25);
    color: #a78bfa;
    font-size: 0.58rem;
    font-weight: 700;
    letter-spacing: 0.05em;
}

html[data-theme='light'] .draft-status-tag {
    background: rgba(124, 58, 237, 0.07);
    border-color: rgba(124, 58, 237, 0.2);
    color: #6d28d9;
}

/* Dimmed / empty slate values */
.slate-empty {
    color: var(--text-muted) !important;
    font-style: italic;
    opacity: 0.6;
}

/* Draft slate — slightly dimmer surface */
.draft-slate {
    opacity: 0.85;
}

.draft-conn-card:hover .draft-slate {
    opacity: 1;
}

/* ── Draft card action buttons ── */
.actions-row-strip.draft-actions {
    margin-top: 1rem;
    padding-top: 0.85rem;
    border-top: 1px solid rgba(255, 255, 255, 0.04);
}

html[data-theme='light'] .actions-row-strip.draft-actions {
    border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.btn-sq-action.resume {
    background: rgba(251, 191, 36, 0.06) !important;
    border: 1px solid rgba(251, 191, 36, 0.3) !important;
    color: #fbbf24 !important;
}

.btn-sq-action.resume:hover {
    background: #fbbf24 !important;
    border-color: #fbbf24 !important;
    color: #0f172a !important;
}

html[data-theme='light'] .btn-sq-action.resume {
    border-color: rgba(217, 119, 6, 0.3) !important;
    background: rgba(217, 119, 6, 0.06) !important;
    color: #b45309 !important;
}

html[data-theme='light'] .btn-sq-action.resume:hover {
    background: #d97706 !important;
    border-color: #d97706 !important;
    color: #fff !important;
}

/* --- BULLETPROOF LIGHT MODE ACTION BUTTONS --- */

/* TEST BUTTON */
html[data-theme='light'] .btn-sq-action.test,
html[data-theme='light'] .btn-sq-action.test:focus {
    background: #e0e7ff !important;
    color: #4f46e5 !important;
    border-color: #a5b4fc !important;
    box-shadow: none !important;
}

html[data-theme='light'] .btn-sq-action.test:hover,
html[data-theme='light'] .btn-sq-action.test:active {
    background: #c7d2fe !important;
    border-color: #818cf8 !important;
    color: #4338ca !important;
    box-shadow: 0 2px 4px rgba(79, 70, 229, 0.1) !important;
}

/* EDIT BUTTON */
html[data-theme='light'] .btn-sq-action.edit,
html[data-theme='light'] .btn-sq-action.edit:focus {
    background: #f3e8ff !important;
    color: #7c3aed !important;
    border-color: #d8b4fe !important;
    box-shadow: none !important;
}

html[data-theme='light'] .btn-sq-action.edit:hover,
html[data-theme='light'] .btn-sq-action.edit:active {
    background: #e9d5ff !important;
    border-color: #c084fc !important;
    color: #6d28d9 !important;
    box-shadow: 0 2px 4px rgba(124, 58, 237, 0.1) !important;
}

/* DELETE BUTTON */
html[data-theme='light'] .btn-sq-action.delete,
html[data-theme='light'] .btn-sq-action.delete:focus {
    background: #fee2e2 !important;
    color: #dc2626 !important;
    border-color: #fca5a5 !important;
    box-shadow: none !important;
}

html[data-theme='light'] .btn-sq-action.delete:hover,
html[data-theme='light'] .btn-sq-action.delete:active {
    background: #fecaca !important;
    border-color: #f87171 !important;
    color: #b91c1c !important;
    box-shadow: 0 2px 4px rgba(220, 38, 38, 0.1) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/dms/DMSConnections.css"],"names":[],"mappings":"AAAA,gDAAgD;;AAEhD,0CAA0C;AAC1C;IACI,iBAAiB;IACjB,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA,wCAAwC;AACxC;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ;;wEAEoE;IACpE,0BAA0B;IAC1B,wEAAwE;IACxE,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI;;8EAE0E;AAC9E;;AAEA,2BAA2B;AAC3B,mFAAmF;;AAEnF,wBAAwB;AACxB;IACI,aAAa;IACb,4DAA4D;IAC5D,WAAW;AACf;;AAEA,+BAA+B;AAC/B;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,kCAAkC;IAClC,eAAe;IACf,oBAAoB;IACpB,2BAA2B;IAC3B,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,oBAAoB;IACpB,qCAAqC;IACrC,oFAAoF;IACpF,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,8BAA8B;AAClC;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gCAAgC;IAChC,YAAY;IACZ,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,kDAAkD;IAClD,+CAA+C;AACnD;;AAEA;IACI,uCAAuC;IACvC,+CAA+C;AACnD;;AAEA,kDAAkD;AAClD;IACI,0BAA0B;IAC1B,kCAAkC;IAClC,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,iEAAiE;IACjE,kDAAkD;IAClD,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,4BAA4B;IAC5B,gCAAgC;IAChC,2CAA2C;AAC/C;;AAEA,mCAAmC;AACnC;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,uDAAuD;AAC3D;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,kCAAkC;IAClC,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,iEAAiE;IACjE,4HAA4H;IAC5H,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,wDAAwD;AAC5D;;AAEA;IACI,2BAA2B;IAC3B,gCAAgC;IAChC,qCAAqC;IACrC,sEAAsE;AAC1E;;AAEA;IACI,+CAA+C;IAC/C,qHAAqH;AACzH;;AAEA;IACI,gDAAgD;IAChD,sHAAsH;AAC1H;;AAEA;IACI,+CAA+C;IAC/C,qHAAqH;AACzH;;AAEA;IACI,8CAA8C;IAC9C,kCAAkC;IAClC,qDAAqD;IACrD,6FAA6F;AACjG;;AAEA;IACI,+CAA+C;IAC/C,kCAAkC;IAClC,sDAAsD;IACtD,8FAA8F;AAClG;;AAEA;IACI,+CAA+C;IAC/C,kCAAkC;IAClC,sDAAsD;IACtD,8FAA8F;AAClG;;AAEA,oCAAoC;AACpC;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;AAChB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,mCAAmC;IACnC,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,kCAAkC;IAClC,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,2CAA2C;AAC/C;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,4CAA4C;AAChD;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,2CAA2C;IAC3C,iCAAiC;AACrC;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,+BAA+B;IAC/B,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;AACvC;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,qCAAqC;IACrC,eAAe;IACf,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;IACxB,qCAAqC;AACzC;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,yCAAyC;IACzC,4CAA4C;AAChD;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,qCAAqC;IACrC,sCAAsC;IACtC,4BAA4B;IAC5B,eAAe;IACf,kDAAkD;IAClD,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,2BAA2B;AAC3B;IACI,oCAAoC;IACpC,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,oCAAoC;IACpC,8CAA8C;IAC9C,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,qCAAqC;IACrC,+CAA+C;IAC/C,2BAA2B;AAC/B;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,oCAAoC;IACpC,8CAA8C;IAC9C,2BAA2B;AAC/B;;AAEA,2CAA2C;AAC3C;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA,+CAA+C;AAC/C;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,wBAAwB;IACxB,0BAA0B;IAC1B,qCAAqC;IACrC,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;IAC9B,kCAAkC;AACtC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,yBAAyB;IACzB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,sDAAsD;IACtD,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,oCAAoC;AACxC;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA,0BAA0B;;AAE1B,wBAAwB;AACxB;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,0BAA0B;IAC1B,sCAAsC;IACtC,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,+BAA+B;AACnC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,6FAA6F;IAC7F,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,qCAAqC;IACrC,0CAA0C;IAC1C,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;IACI,0DAA0D;AAC9D;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI;QACI,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,YAAY;IAChB;AACJ;;AAEA,0DAA0D;AAC1D;IACI,0BAA0B;IAC1B,kCAAkC;IAClC,2BAA2B;IAC3B,wDAAwD;AAC5D;;AAEA;IACI,8CAA8C;IAC9C,kCAAkC;IAClC,sDAAsD;IACtD,6FAA6F;AACjG;;AAEA;IACI,+CAA+C;IAC/C,kCAAkC;IAClC,uDAAuD;IACvD,8FAA8F;AAClG;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,iCAAiC;IACjC,+BAA+B;IAC/B,2BAA2B;IAC3B,mCAAmC;IACnC,2CAA2C;IAC3C,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,qCAAqC;IACrC,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,2CAA2C;AAC/C;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iCAAiC;IACjC,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,gDAAgD;IAChD,qDAAqD;IACrD,0CAA0C;IAC1C,uCAAuC;IACvC,8BAA8B;IAC9B,6BAA6B;IAC7B,qBAAqB;IACrB;;;yDAGqD;IACrD,4DAA4D;AAChE;;AAEA;;IAEI,6CAA6C;IAC7C,qDAAqD;IACrD,0CAA0C;IAC1C,uCAAuC;IACvC,8BAA8B;IAC9B,6BAA6B;IAC7B,qBAAqB;IACrB;;;0DAGsD;IACtD,4DAA4D;AAChE;;AAEA,qBAAqB;AACrB;;IAEI,sCAAsC;AAC1C;;AAEA;;IAEI;;;yDAGqD;AACzD;;AAEA;;IAEI;;;0DAGsD;AAC1D;;AAEA,wEAAwE;AACxE;;IAEI,sBAAsB;IACtB,6BAA6B;IAC7B,sBAAsB;IACtB,yBAAyB;IACzB,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,+BAA+B;IAC/B,yBAAyB;IACzB,yFAAyF;IAEzF,kCAAkC;IAClC,4DAA4D;IAC5D,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA,kEAAkE;AAClE;;IAEI,wBAAwB;IACxB,wBAAwB;AAC5B;;AAEA,iDAAiD;AACjD;;IAEI,gEAAgE;AACpE;;AAEA;;IAEI,gEAAgE;AACpE;;AAEA;;IAEI,gEAAgE;AACpE;;AAEA,oDAAoD;;AAEpD,uDAAuD;AACvD;;IAEI,gDAAgD;IAChD,sDAAsD;IACtD,2DAA2D;AAC/D;;AAEA;;IAEI,gDAAgD;IAChD,qDAAqD;IACrD,0DAA0D;AAC9D;;AAEA,4DAA4D;AAC5D;;IAEI,4CAA4C;IAC5C,sCAAsC;IACtC,yFAAyF;AAC7F;;AAEA;;IAEI,4CAA4C;IAC5C,sCAAsC;IACtC,wFAAwF;AAC5F;;AAEA,8BAA8B;AAC9B;;IAEI,uBAAuB;AAC3B;;AAEA,sCAAsC;AACtC;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;IAC9B,sDAAsD;IACtD,oDAAoD;AACxD;;AAEA;IACI,8BAA8B;IAC9B,gDAAgD;IAChD,qDAAqD;AACzD;;AAEA,mCAAmC;AACnC;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,2BAA2B;IAC3B,iCAAiC;IACjC,iCAAiC;AACrC;;AAEA,oBAAoB;AACpB;IACI,+CAA+C;IAC/C,yBAAyB;IACzB,oDAAoD;AACxD;;AAEA;IACI,8CAA8C;IAC9C,yBAAyB;IACzB,oDAAoD;AACxD;;AAEA,uBAAuB;AACvB;IACI,+CAA+C;IAC/C,yBAAyB;IACzB,oDAAoD;AACxD;;AAEA;IACI,8CAA8C;IAC9C,yBAAyB;IACzB,oDAAoD;AACxD;;AAEA,6BAA6B;AAC7B;IACI,gDAAgD;IAChD,sDAAsD;IACtD,yBAAyB;IACzB,2BAA2B;IAC3B,4BAA4B;IAC5B,kCAAkC;IAClC,6BAA6B;IAC7B,iCAAiC;AACrC;;AAEA;IACI,0CAA0C;IAC1C,gDAAgD;IAChD,yBAAyB;AAC7B;;AAEA,wBAAwB;AACxB;;IAEI,8BAA8B;IAC9B,sDAAsD;IACtD,8BAA8B;IAC9B,0DAA0D;AAC9D;;AAEA;;IAEI,gDAAgD;IAChD,sDAAsD;IACtD,8BAA8B;IAC9B,gEAAgE;AACpE;;AAEA;IACI,gDAAgD;IAChD,kDAAkD;AACtD;;AAEA,kDAAkD;AAClD;;IAEI,0CAA0C;IAC1C,gDAAgD;IAChD,8BAA8B;IAC9B,0DAA0D;AAC9D;;AAEA;;IAEI,+CAA+C;IAC/C,qDAAqD;AACzD;;AAEA;;IAEI,+CAA+C;IAC/C,oDAAoD;AACxD;;AAEA;;IAEI,8BAA8B;IAC9B,gDAAgD;IAChD,8BAA8B;IAC9B,oDAAoD;AACxD;;AAEA;IACI,8BAA8B;IAC9B,iDAAiD;IACjD,oDAAoD;AACxD;;AAEA,uBAAuB;AACvB;;;;IAII,gDAAgD;IAChD,qCAAqC;IACrC,8BAA8B;IAC9B,4DAA4D;IAC5D,2BAA2B;IAC3B,6BAA6B;IAC7B,iCAAiC;IACjC,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA,uBAAuB;AACvB;;IAEI,+CAA+C;IAC/C,qDAAqD;IACrD,yBAAyB;AAC7B;;AAEA;;IAEI,8CAA8C;IAC9C,gCAAgC;IAChC,sCAAsC;AAC1C;;AAEA;;IAEI,+CAA+C;IAC/C,qDAAqD;IACrD,yBAAyB;AAC7B;;AAEA;;IAEI,8CAA8C;IAC9C,gCAAgC;IAChC,sCAAsC;AAC1C;;AAEA;;IAEI,8CAA8C;IAC9C,oDAAoD;IACpD,yBAAyB;AAC7B;;AAEA;;IAEI,8CAA8C;IAC9C,gCAAgC;IAChC,sCAAsC;AAC1C;;AAEA,yEAAyE;AACzE;;IAEI,+CAA+C;IAC/C,qDAAqD;IACrD,yBAAyB;AAC7B;;AAEA;;IAEI,+CAA+C;IAC/C,gCAAgC;IAChC,sCAAsC;AAC1C;;AAEA;;IAEI,+CAA+C;IAC/C,qDAAqD;IACrD,yBAAyB;AAC7B;;AAEA;;IAEI,+CAA+C;IAC/C,gCAAgC;IAChC,sCAAsC;AAC1C;;AAEA;;IAEI,8CAA8C;IAC9C,oDAAoD;IACpD,yBAAyB;AAC7B;;AAEA;;IAEI,8CAA8C;IAC9C,gCAAgC;IAChC,sCAAsC;AAC1C;;AAEA,sCAAsC;AACtC;;IAEI,+BAA+B;IAC/B,2BAA2B;IAC3B,6BAA6B;IAC7B,iCAAiC;IACjC,oCAAoC;IACpC,mCAAmC;IACnC,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA,qCAAqC;AACrC;IACI,sDAAsD;IACtD,yBAAyB;AAC7B;;AAEA;IACI,qDAAqD;IACrD,yBAAyB;AAC7B;;AAEA,oCAAoC;AACpC;IACI,oDAAoD;IACpD,yBAAyB;AAC7B;;AAEA;IACI,mDAAmD;IACnD,yBAAyB;AAC7B;;AAEA,+BAA+B;AAC/B;IACI,kCAAkC;IAClC,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA,kDAAkD;AAClD;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;;IAEI,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;;IAEI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;;IAEI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;;IAEI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA,2DAA2D;AAC3D;;IAEI,gDAAgD;IAChD,sDAAsD;IACtD,2DAA2D;AAC/D;;AAEA;;IAEI,4CAA4C;IAC5C,sCAAsC;IACtC,yFAAyF;AAC7F;;AAEA;IACI,sDAAsD;IACtD,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA;IACI,oDAAoD;IACpD,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA;;IAEI,+CAA+C;IAC/C,qDAAqD;AACzD;;AAEA;;+EAE+E;;AAE/E;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;IACZ,+BAA+B;IAC/B,qBAAqB;IACrB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI;QACI,sBAAsB;QACtB,oBAAoB;QACpB,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,SAAO;IACX;AACJ;;AAEA,uCAAuC;AACvC;IACI,kBAAkB;IAClB,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,mDAAmD;IACnD,2BAA2B;IAC3B,gEAAgE;IAChE,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,8CAA8C;IAC9C,kDAAkD;AACtD;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,+EAA+E;AACnF;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,SAAO;IACP,uBAAuB;IACvB,kCAAkC;IAClC,qCAAqC;IACrC,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,wBAAwB;IACxB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,kCAAkC;AAClC;IACI,gDAAgD;IAChD,2HAA2H;AAC/H;;AAEA;IACI,gDAAgD;IAChD,gFAAgF;AACpF;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI;QACI,2BAA2B;QAC3B,WAAW;IACf;;IAEA;QACI,SAAO;IACX;;IAEA;QACI,WAAW;QACX,8BAA8B;IAClC;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,qCAAqC;IACrC,2BAA2B;IAC3B,2CAA2C;IAC3C,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kDAAkD;IAClD,0CAA0C;AAC9C;;AAEA;IACI,+BAA+B;IAC/B,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,uCAAuC;IACvC,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,+BAA+B;IAC/B,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,kCAAkC;AAClC;IACI,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,YAAY;IACZ,kCAAkC;IAClC,0CAA0C;IAC1C,2CAA2C;IAC3C,mBAAmB;IACnB,eAAe;IACf,mFAAmF;IACnF,aAAa;;IAEb,UAAU;IACV,kBAAkB;IAClB,oBAAoB;IACpB,uCAAuC;IACvC,yDAAyD;AAC7D;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,oBAAoB;IACpB,oEAAoE;AACxE;;AAEA;IACI,qCAAqC;IACrC,qCAAqC;IACrC,2CAA2C;AAC/C;;AAEA;IACI;QACI,UAAU;QACV,uCAAuC;IAC3C;;IAEA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,wBAAwB;IACxB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,2CAA2C;AAC3C;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,qCAAqC;IACrC,2BAA2B;IAC3B,sCAAsC;IACtC,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,qCAAqC;IACrC,qCAAqC;IACrC,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qCAAqC;IACrC,2BAA2B;AAC/B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;;+EAE+E;;AAE/E;IACI,gBAAgB;IAChB,iBAAiB;IACjB,+CAA+C;AACnD;;AAEA,4CAA4C;AAC5C;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,qCAAqC;IACrC,2BAA2B;IAC3B,mCAAmC;IACnC,2CAA2C;IAC3C,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;IACZ,QAAQ;IACR,qFAAqF;IACrF,kDAAkD;AACtD;;AAEA;IACI,gCAAgC;IAChC,iCAAiC;IACjC,8EAA8E;AAClF;;AAEA,oCAAoC;AACpC;IACI,2BAA2B;IAC3B,qCAAqC;IACrC;;;iDAG6C;AACjD;;AAEA;IACI,sCAAsC;IACtC,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;IAC7B,uBAAuB;IACvB,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,kDAAkD;IAClD,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,0BAA0B;IAC1B,qCAAqC;AACzC;;AAEA;IACI,+BAA+B;AACnC;;AAEA,sFAAsF;AACtF;IACI,UAAU;IACV,yBAAyB;IACzB,0GAA0G;IAC1G,oDAAoD;IACpD;;;0DAGsD;AAC1D;;AAEA;IACI,yGAAyG;IACzG,yBAAyB;IACzB,oDAAoD;IACpD;;;yDAGqD;AACzD;;AAEA,uDAAuD;AACvD;IACI,WAAW;IACX,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;IAC3B,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA,mDAAmD;AACnD;IACI,kDAAkD;AACtD;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA,8CAA8C;AAC9C;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,qCAAqC;IACrC,gBAAgB;IAChB,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI,+BAA+B;IAC/B,iCAAiC;AACrC;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,oDAAoD;IACpD,oDAAoD;AACxD;;AAEA;IACI,oDAAoD;AACxD;;AAEA,gCAAgC;AAChC;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,kCAAkC;IAClC,6CAA6C;IAC7C,0CAA0C;IAC1C,kDAAkD;IAClD,eAAe;IACf,kDAAkD;IAClD,UAAU;IACV,kEAAkE;IAClE,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,uCAAuC;AAC3C;;AAEA;IACI;QACI,UAAU;QACV,uCAAuC;IAC3C;;IAEA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA,gBAAgB;AAChB;IACI,2BAA2B;IAC3B,sCAAsC;IACtC,kCAAkC;IAClC;;;+CAG2C;AAC/C;;AAEA;IACI,qCAAqC;IACrC,qCAAqC;IACrC,8EAA8E;AAClF;;AAEA,gCAAgC;AAChC;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX;;;;6BAIyB;IACzB,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA,4BAA4B;AAC5B;IACI;;;yCAGqC;AACzC;;AAEA;IACI;;;yCAGqC;AACzC;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,cAAc;IACd,oBAAoB;IACpB,mCAAmC;IACnC,yCAAyC;IACzC,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;IACnC,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,cAAc;IACd,oBAAoB;IACpB,mCAAmC;IACnC,yCAAyC;IACzC,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;IACnC,oCAAoC;IACpC,cAAc;AAClB;;AAEA,sDAAsD;AACtD;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA,qBAAqB;AACrB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,mCAAmC;IACnC,0CAA0C;IAC1C,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;IACrC,cAAc;AAClB;;AAEA,gCAAgC;AAChC;IACI,mCAAmC;IACnC,kBAAkB;IAClB,YAAY;AAChB;;AAEA,0CAA0C;AAC1C;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA,oCAAoC;AACpC;IACI,gBAAgB;IAChB,oBAAoB;IACpB,+CAA+C;AACnD;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,+CAA+C;IAC/C,oDAAoD;IACpD,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,+CAA+C;IAC/C,8CAA8C;IAC9C,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA,kDAAkD;;AAElD,gBAAgB;AAChB;;IAEI,8BAA8B;IAC9B,yBAAyB;IACzB,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;;IAEI,8BAA8B;IAC9B,gCAAgC;IAChC,yBAAyB;IACzB,uDAAuD;AAC3D;;AAEA,gBAAgB;AAChB;;IAEI,8BAA8B;IAC9B,yBAAyB;IACzB,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;;IAEI,8BAA8B;IAC9B,gCAAgC;IAChC,yBAAyB;IACzB,wDAAwD;AAC5D;;AAEA,kBAAkB;AAClB;;IAEI,8BAA8B;IAC9B,yBAAyB;IACzB,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;;IAEI,8BAA8B;IAC9B,gCAAgC;IAChC,yBAAyB;IACzB,uDAAuD;AAC3D","sourcesContent":["/* DMSConnections.css - Premium Beautification */\n\n/* --- Page Container & Global Depth --- */\n.dms-connections-container {\n    max-width: 1800px;\n    margin: 0;\n    padding: 0 0 4rem;\n    position: relative;\n    z-index: 1;\n}\n\n/* Subtle Data Grid Background Pattern */\n.dms-connections-container::before {\n    content: '';\n    position: absolute;\n    inset: -20px;\n    background-image:\n        linear-gradient(rgba(0, 0, 0, 0.02) 1px, transparent 1px),\n        linear-gradient(90deg, rgba(0, 0, 0, 0.02) 1px, transparent 1px);\n    background-size: 50px 50px;\n    mask-image: radial-gradient(circle at center, black 0%, transparent 80%);\n    pointer-events: none;\n    z-index: -1;\n}\n\nhtml[data-theme=\"dark\"] .dms-connections-container::before {\n    background-image:\n        linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),\n        linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);\n}\n\n/* --- Header Section --- */\n/* Header classes removed in favor of global dms-page-header in EnterpriseDMS.css */\n\n/* --- Grid Layout --- */\n.dms-connections-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));\n    gap: 2.5rem;\n}\n\n/* Header Actions & Stats Bar */\n.header-actions-premium {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 1.5rem;\n}\n\n.stats-summary-bar {\n    display: flex;\n    align-items: center;\n    background: var(--surface);\n    backdrop-filter: var(--glass-blur);\n    padding: 0.6rem;\n    border-radius: 100px;\n    border: var(--glass-border);\n    box-shadow: var(--glass-shadow);\n}\n\n.stat-pill {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 0.4rem 1.25rem;\n    border-radius: 100px;\n    background: rgba(255, 255, 255, 0.03);\n    box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.05), 0 2px 8px rgba(0, 0, 0, 0.05);\n    transition: background 0.3s ease;\n}\n\n.stat-pill:hover {\n    background: rgba(255, 255, 255, 0.06);\n}\n\n.stat-pill.verified {\n    background: rgba(16, 185, 129, 0.05);\n}\n\n.stat-pill.failed {\n    background: rgba(239, 68, 68, 0.05);\n}\n\n.stat-label {\n    font-size: 0.65rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    color: var(--text-muted);\n    letter-spacing: 0.08em;\n}\n\n.stat-count {\n    font-size: 1rem;\n    font-weight: 600;\n    color: var(--text-main);\n    font-family: 'Outfit', monospace;\n}\n\n.stat-divider {\n    width: 1px;\n    height: 18px;\n    background: var(--card-border);\n}\n\n/* Premium Add Button */\n.btn-add-nexus {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    background: var(--gradient-main);\n    color: white;\n    padding: 0.85rem 2.25rem;\n    border-radius: 16px;\n    font-weight: 600;\n    font-size: 1rem;\n    border: none;\n    cursor: pointer;\n    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n    box-shadow: 0 10px 30px rgba(99, 102, 241, 0.3);\n}\n\n.btn-add-nexus:hover {\n    transform: translateY(-4px) scale(1.02);\n    box-shadow: 0 20px 45px rgba(99, 102, 241, 0.4);\n}\n\n/* --- Premium Connection Card (Nexus Glass) --- */\n.dms-conn-card {\n    background: var(--card-bg);\n    backdrop-filter: var(--glass-blur);\n    border: var(--glass-border);\n    border-radius: 28px;\n    padding: 1.75rem;\n    position: relative;\n    opacity: 0;\n    animation: dropInBlur 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n    transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);\n    display: flex;\n    flex-direction: column;\n    gap: 1.25rem;\n    overflow: hidden;\n    box-shadow: var(--glass-shadow);\n}\n\n@keyframes dropInBlur {\n    from {\n        opacity: 0;\n        transform: translateY(15px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.dms-conn-card:hover {\n    transform: translateY(-10px);\n    background: var(--card-hover-bg);\n    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.15);\n}\n\n/* Role Accents - Radiant Borders */\n.dms-conn-card::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 5px;\n    opacity: 0.8;\n}\n\n.dms-conn-card:has(.aws)::before {\n    background: linear-gradient(to right, #FF9900, #FFC300);\n}\n\n.dms-conn-card:has(.gcp)::before {\n    background: linear-gradient(to right, #4285F4, #34A853);\n}\n\n.dms-conn-card:has(.azure)::before {\n    background: linear-gradient(to right, #0089D6, #00BCF2);\n}\n\n/* Top Badge Row */\n.card-top-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.dms-conn-card {\n    background: var(--card-bg);\n    backdrop-filter: var(--glass-blur);\n    border: var(--glass-border);\n    border-radius: 28px;\n    padding: 1.75rem;\n    position: relative;\n    opacity: 0;\n    animation: dropInBlur 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n    transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.4s ease, border-color 0.4s ease, background 0.4s ease;\n    display: flex;\n    flex-direction: column;\n    gap: 1.25rem;\n    overflow: hidden;\n    box-shadow: var(--glass-shadow), var(--glass-inner-glow);\n}\n\n.dms-conn-card:hover {\n    transform: translateY(-4px);\n    background: var(--card-hover-bg);\n    border-color: rgba(99, 102, 241, 0.3);\n    box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.15), var(--glass-shadow);\n}\n\n.dms-conn-card:hover:has(.aws) {\n    border-color: rgba(255, 153, 0, 0.4) !important;\n    box-shadow: 0 30px 60px -10px rgba(0, 0, 0, 0.4), 0 0 20px rgba(255, 153, 0, 0.2), var(--glass-inner-glow) !important;\n}\n\n.dms-conn-card:hover:has(.gcp) {\n    border-color: rgba(66, 133, 244, 0.4) !important;\n    box-shadow: 0 30px 60px -10px rgba(0, 0, 0, 0.4), 0 0 20px rgba(66, 133, 244, 0.2), var(--glass-inner-glow) !important;\n}\n\n.dms-conn-card:hover:has(.azure) {\n    border-color: rgba(0, 137, 214, 0.4) !important;\n    box-shadow: 0 30px 60px -10px rgba(0, 0, 0, 0.4), 0 0 20px rgba(0, 137, 214, 0.2), var(--glass-inner-glow) !important;\n}\n\n.dms-conn-card.failed {\n    background: rgba(239, 68, 68, 0.02) !important;\n    backdrop-filter: var(--glass-blur);\n    border: 1.5px solid rgba(239, 68, 68, 0.3) !important;\n    box-shadow: 0 15px 35px rgba(239, 68, 68, 0.04), var(--glass-shadow), var(--glass-inner-glow);\n}\n\n.dms-conn-card.success {\n    background: rgba(16, 185, 129, 0.02) !important;\n    backdrop-filter: var(--glass-blur);\n    border: 1.5px solid rgba(16, 185, 129, 0.3) !important;\n    box-shadow: 0 15px 35px rgba(16, 185, 129, 0.04), var(--glass-shadow), var(--glass-inner-glow);\n}\n\n.dms-conn-card.checking {\n    background: rgba(99, 102, 241, 0.02) !important;\n    backdrop-filter: var(--glass-blur);\n    border: 1.5px solid rgba(99, 102, 241, 0.3) !important;\n    box-shadow: 0 15px 35px rgba(99, 102, 241, 0.04), var(--glass-shadow), var(--glass-inner-glow);\n}\n\n/* Role Accents - Subtle Indicator */\n.dms-conn-card.role-source::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 6px;\n    background: #94A3B8;\n    /* Muted as per reference */\n    opacity: 0.3;\n}\n\n/* Top Badge Row */\n.card-top-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    min-height: 28px;\n}\n\n.role-badge-pill {\n    padding: 0.25rem 0.85rem;\n    background: rgba(168, 85, 247, 0.1);\n    color: #6D28D9;\n    font-size: 0.65rem;\n    font-weight: 600;\n    border-radius: 8px;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n}\n\n.connectivity-chips-group {\n    display: flex;\n    align-items: center;\n    gap: 1.5rem;\n}\n\n.connectivity-label {\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n    font-size: 0.7rem;\n    font-weight: 500;\n    color: var(--text-secondary);\n    letter-spacing: 0.02em;\n}\n\n.status-badge-pill {\n    padding: 0.25rem 0.6rem;\n    border-radius: 100px;\n    font-size: 0.65rem;\n    font-weight: 600;\n    letter-spacing: 0.05em;\n}\n\n.status-badge-pill.failed {\n    background: rgba(220, 38, 38, 0.1);\n    color: #DC2626;\n    border: 1.5px solid rgba(220, 38, 38, 0.3);\n}\n\n.status-badge-pill.success {\n    background: rgba(16, 185, 129, 0.1);\n    color: #059669;\n    border: 1.5px solid rgba(16, 185, 129, 0.3);\n}\n\n.status-badge-pill.unknown {\n    background: rgba(148, 163, 184, 0.1);\n    color: #64748B;\n    border: 1.5px solid rgba(148, 163, 184, 0.3);\n}\n\n.status-badge-pill.checking {\n    background: rgba(99, 102, 241, 0.1);\n    color: #4F46E5;\n    border: 1.5px solid rgba(99, 102, 241, 0.3);\n    animation: pulse-soft 2s infinite;\n}\n\n@keyframes pulse-soft {\n    0% {\n        opacity: 1;\n    }\n\n    50% {\n        opacity: 0.6;\n    }\n\n    100% {\n        opacity: 1;\n    }\n}\n\n/* Card Body Main */\n.card-identity-header {\n    display: flex;\n    align-items: flex-start;\n    gap: 1rem;\n    position: relative;\n    padding: 0.25rem 0;\n    width: 100%;\n}\n\n.provider-avatar-glass {\n    width: 60px;\n    height: 60px;\n    background: var(--surface-light);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);\n    flex-shrink: 0;\n}\n\n.title-stack-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n    min-width: 0;\n    /* Essential for flex shrinking */\n}\n\n.primary-title-row {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n}\n\n.primary-title-row h3 {\n    margin: 0;\n    font-size: 1.25rem;\n    font-weight: 500;\n    color: var(--text-primary);\n    letter-spacing: -0.01em;\n}\n\n.subtitle-detail {\n    font-size: 0.85rem;\n    font-weight: 500;\n    color: var(--text-primary);\n}\n\n.region-pill-min {\n    font-size: 0.65rem;\n    font-weight: 500;\n    color: var(--text-primary);\n    background: rgba(0, 0, 0, 0.05);\n    padding: 0.2rem 0.5rem;\n    border-radius: 4px;\n}\n\n.dms-conn-card:hover .db-icon-outer {\n    transform: rotate(-8deg) scale(1.1);\n}\n\n/* Premium Details Grid */\n.details-grid-premium {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 1.25rem;\n    background: rgba(255, 255, 255, 0.02);\n    padding: 1.5rem;\n    border-radius: 20px;\n    border: 1px solid var(--border-glass);\n}\n\n.detail-item {\n    display: flex;\n    gap: 0.85rem;\n    align-items: center;\n}\n\n.detail-icon {\n    width: 32px;\n    height: 32px;\n    border-radius: 10px;\n    background: rgba(255, 255, 255, 0.04);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-muted);\n    border: 1px solid var(--border-glass);\n}\n\n/* Actions Row Strip */\n.actions-row-strip {\n    display: flex;\n    gap: 0.5rem;\n    align-items: center;\n    padding: 0.5rem 0;\n    border-top: 1px solid rgba(0, 0, 0, 0.03);\n    border-bottom: 1px solid rgba(0, 0, 0, 0.03);\n}\n\nhtml[data-theme='dark'] .actions-row-strip {\n    border-color: rgba(255, 255, 255, 0.05);\n}\n\n.btn-sq-action {\n    flex: 1;\n    height: 38px;\n    padding: 0 0.5rem;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    border: 1px solid var(--border-color);\n    background: var(--bg-button-secondary);\n    color: var(--text-secondary);\n    cursor: pointer;\n    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n    font-size: 0.65rem;\n    font-weight: 600;\n    letter-spacing: 0.08em;\n}\n\n/* Specific Action Colors */\n.btn-sq-action.test {\n    background: rgba(99, 102, 241, 0.08);\n    color: #4f46e5;\n    border-color: rgba(99, 102, 241, 0.2);\n}\n\n.btn-sq-action.test:hover {\n    background: rgba(79, 70, 229, 0.15);\n    color: #4338ca;\n    border-color: rgba(79, 70, 229, 0.3);\n    box-shadow: 0 4px 12px rgba(79, 70, 229, 0.15);\n    transform: translateY(-2px);\n}\n\n.btn-sq-action.edit {\n    background: rgba(168, 85, 247, 0.08);\n    color: #7c3aed;\n    border-color: rgba(168, 85, 247, 0.2);\n}\n\n.btn-sq-action.edit:hover {\n    background: rgba(124, 58, 237, 0.15);\n    color: #6d28d9;\n    border-color: rgba(124, 58, 237, 0.3);\n    box-shadow: 0 4px 12px rgba(124, 58, 237, 0.15);\n    transform: translateY(-2px);\n}\n\n.btn-sq-action.delete {\n    background: rgba(239, 68, 68, 0.08);\n    color: #dc2626;\n    border-color: rgba(239, 68, 68, 0.2);\n}\n\n.btn-sq-action.delete:hover {\n    background: rgba(220, 38, 38, 0.15);\n    color: #b91c1c;\n    border-color: rgba(220, 38, 38, 0.3);\n    box-shadow: 0 4px 12px rgba(220, 38, 38, 0.15);\n    transform: translateY(-2px);\n}\n\n/* Dark Mode Overrides for Action Buttons */\nhtml[data-theme='dark'] .btn-sq-action.test {\n    background: rgba(99, 102, 241, 0.15);\n    color: #a5b4fc;\n}\n\nhtml[data-theme='dark'] .btn-sq-action.edit {\n    background: rgba(168, 85, 247, 0.15);\n    color: #c084fc;\n}\n\nhtml[data-theme='dark'] .btn-sq-action.delete {\n    background: rgba(239, 68, 68, 0.15);\n    color: #f87171;\n}\n\nhtml[data-theme='dark'] .btn-sq-action:hover {\n    background: white;\n    color: #0f172a;\n    border-color: white;\n}\n\n/* Inner Data Slate - Organized & Presentable */\n.inner-data-slate {\n    background: rgba(0, 0, 0, 0.02);\n    border-radius: 12px;\n    padding: 1rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n    border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\nhtml[data-theme='dark'] .inner-data-slate {\n    background: rgba(255, 255, 255, 0.03);\n    border-color: rgba(255, 255, 255, 0.05);\n}\n\n.slate-item-box {\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n    padding: 0.65rem 0.75rem;\n    background: var(--bg-card);\n    border: 1px solid var(--border-glass);\n    border-radius: 12px;\n    transition: all 0.2s ease;\n    min-width: 0;\n}\n\n.slate-item-box:hover {\n    transform: translateY(-2px);\n    box-shadow: var(--shadow-soft);\n    border-color: var(--primary-color);\n}\n\n.slate-item-box.full {\n    width: 100%;\n}\n\n.slate-label-row {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.slate-item-icon {\n    color: var(--text-muted);\n    opacity: 0.8;\n}\n\n.slate-item-icon.secure {\n    color: #10b981;\n}\n\n.slate-label {\n    font-size: 0.72rem;\n    font-weight: 800;\n    color: var(--text-muted);\n    text-transform: uppercase;\n    letter-spacing: 0.12em;\n    opacity: 0.9;\n}\n\n.slate-value {\n    font-family: 'Outfit', 'Plus Jakarta Sans', sans-serif;\n    font-size: 1.05rem;\n    font-weight: 400;\n    color: var(--text-secondary);\n    word-break: break-all;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.secure-text {\n    color: #059669 !important;\n}\n\n.slate-grid-row {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 0.75rem;\n}\n\n.slate-grid-row.tri {\n    grid-template-columns: 1fr 1fr 1.2fr;\n}\n\n/* Footer Mini */\n.card-footer-mini {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: -0.5rem;\n}\n\n.footer-meta-right {\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n}\n\n.provider-name-mini {\n    font-size: 0.7rem;\n    font-weight: 600;\n    color: var(--text-muted);\n}\n\n.date-stamp-mini {\n    font-size: 0.7rem;\n    color: var(--text-muted);\n}\n\n/* Redundant tag removed */\n\n/* --- Empty State --- */\n.empty-state-card {\n    grid-column: 1 / -1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 8rem 2rem;\n    background: var(--bg-card);\n    border: 2px dashed var(--border-glass);\n    border-radius: 40px;\n    text-align: center;\n    gap: 2rem;\n    animation: fadeIn 0.8s ease-out;\n}\n\n.empty-state-icon {\n    width: 120px;\n    height: 120px;\n    background: linear-gradient(135deg, rgba(124, 58, 237, 0.1) 0%, rgba(219, 39, 119, 0.1) 100%);\n    border-radius: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-accent);\n    border: 1px solid var(--border-glass);\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n    transform: rotate(-10deg);\n}\n\n.empty-state-card h3 {\n    font-size: 2rem;\n    font-weight: 600;\n    margin: 0;\n    color: var(--text-primary);\n}\n\n.empty-state-card p {\n    color: var(--text-muted);\n    font-size: 1.15rem;\n    max-width: 450px;\n    line-height: 1.6;\n}\n\n/* --- Animations --- */\n.spin-smooth {\n    animation: spin 1.5s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n}\n\n@keyframes spin {\n    from {\n        transform: rotate(0deg);\n    }\n\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.pulse-ring {\n    animation: pulse-ring 2s infinite;\n}\n\n@keyframes pulse-ring {\n    0% {\n        transform: scale(0.95);\n        opacity: 0.5;\n    }\n\n    50% {\n        transform: scale(1.05);\n        opacity: 1;\n    }\n\n    100% {\n        transform: scale(0.95);\n        opacity: 0.5;\n    }\n}\n\n/* --- Dark Mode Precision Overrides (Data Slate V3) --- */\nhtml[data-theme='dark'] .dms-conn-card {\n    background: var(--card-bg);\n    backdrop-filter: var(--glass-blur);\n    border: var(--glass-border);\n    box-shadow: var(--glass-shadow), var(--glass-inner-glow);\n}\n\nhtml[data-theme='dark'] .dms-conn-card.failed {\n    background: rgba(239, 68, 68, 0.04) !important;\n    backdrop-filter: var(--glass-blur);\n    border: 1.5px solid rgba(239, 68, 68, 0.35) !important;\n    box-shadow: 0 15px 35px rgba(239, 68, 68, 0.08), var(--glass-shadow), var(--glass-inner-glow);\n}\n\nhtml[data-theme='dark'] .dms-conn-card.success {\n    background: rgba(16, 185, 129, 0.04) !important;\n    backdrop-filter: var(--glass-blur);\n    border: 1.5px solid rgba(16, 185, 129, 0.35) !important;\n    box-shadow: 0 15px 35px rgba(16, 185, 129, 0.08), var(--glass-shadow), var(--glass-inner-glow);\n}\n\nhtml[data-theme='dark'] .primary-title-row h3 {\n    color: var(--text-primary);\n}\n\nhtml[data-theme='dark'] .dms-conn-card.failed .primary-title-row h3,\nhtml[data-theme='dark'] .dms-conn-card.failed .subtitle-detail {\n    color: var(--text-primary);\n}\n\nhtml[data-theme='dark'] .inner-data-slate {\n    background: rgba(15, 23, 42, 0.7);\n    /* Translucent dark workspace */\n    backdrop-filter: blur(20px);\n    -webkit-backdrop-filter: blur(20px);\n    border: 1px solid rgba(255, 255, 255, 0.05);\n    box-shadow: inset 0 4px 12px rgba(0, 0, 0, 0.5);\n}\n\nhtml[data-theme='dark'] .slate-label {\n    color: #94A3B8;\n    /* Muted silver */\n}\n\nhtml[data-theme='dark'] .slate-value {\n    color: #F8FAF8;\n    /* Crisp white */\n}\n\nhtml[data-theme='dark'] .btn-sq-action {\n    background: rgba(15, 23, 42, 0.8);\n    border-color: rgba(255, 255, 255, 0.1);\n    color: #CBD5E1;\n}\n\nhtml[data-theme='dark'] .btn-sq-action:hover {\n    background: white;\n    color: #0F172A;\n}\n\nhtml[data-theme='dark'] .btn-sq-action.delete {\n    color: #f87171;\n    /* Brighter red for dark mode */\n    background: rgba(248, 113, 113, 0.08);\n    border-color: rgba(248, 113, 113, 0.15);\n}\n\nhtml[data-theme='dark'] .btn-sq-action.delete:hover {\n    background: #ef4444;\n    color: white;\n    border-color: #ef4444;\n    box-shadow: 0 0 20px rgba(239, 68, 68, 0.4);\n}\n\nhtml[data-theme='dark'] .role-badge-pill {\n    background: rgba(139, 92, 246, 0.2);\n    color: #A78BFA;\n}\n\nhtml[data-theme='dark'] .connectivity-label {\n    color: #94A3B8;\n}\n\nhtml[data-theme='dark'] .provider-avatar-glass {\n    background: rgba(30, 41, 59, 0.8);\n    /* Deep slate for dark mode */\n}\n\nhtml[data-theme='dark'] .footer-meta-right {\n    opacity: 0.6;\n}\n\nhtml[data-theme=\"light\"] .dms-conn-card,\nhtml[data-theme=\"light\"] .connection-card {\n    background: rgba(255, 255, 255, 0.75) !important;\n    backdrop-filter: blur(24px) saturate(180%) !important;\n    border: 1.5px solid transparent !important;\n    background-clip: padding-box !important;\n    border-radius: 24px !important;\n    position: relative !important;\n    z-index: 1 !important;\n    box-shadow:\n        0 12px 30px rgba(0, 0, 0, 0.04),\n        0 4px 10px rgba(0, 0, 0, 0.02),\n        inset 0 1px 0 rgba(255, 255, 255, 0.6) !important;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\nhtml[data-theme=\"dark\"] .dms-conn-card,\nhtml[data-theme=\"dark\"] .connection-card {\n    background: rgba(10, 15, 30, 0.85) !important;\n    backdrop-filter: blur(24px) saturate(180%) !important;\n    border: 1.5px solid transparent !important;\n    background-clip: padding-box !important;\n    border-radius: 24px !important;\n    position: relative !important;\n    z-index: 1 !important;\n    box-shadow:\n        0 20px 40px rgba(0, 0, 0, 0.18),\n        0 8px 18px rgba(0, 0, 0, 0.08),\n        inset 0 1px 0 rgba(255, 255, 255, 0.08) !important;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n/* Hover elevations */\n.dms-conn-card:hover,\n.connection-card:hover {\n    transform: translateY(-4px) !important;\n}\n\nhtml[data-theme=\"light\"] .dms-conn-card:hover,\nhtml[data-theme=\"light\"] .connection-card:hover {\n    box-shadow:\n        0 20px 40px rgba(0, 0, 0, 0.08),\n        0 8px 16px rgba(0, 0, 0, 0.04),\n        inset 0 1px 0 rgba(255, 255, 255, 0.7) !important;\n}\n\nhtml[data-theme=\"dark\"] .dms-conn-card:hover,\nhtml[data-theme=\"dark\"] .connection-card:hover {\n    box-shadow:\n        0 30px 60px rgba(0, 0, 0, 0.25),\n        0 12px 24px rgba(0, 0, 0, 0.12),\n        inset 0 1px 0 rgba(255, 255, 255, 0.12) !important;\n}\n\n/* Card Gradient Border Pseudo Elements (For default non-tested state) */\n.dms-conn-card::before,\n.connection-card::before {\n    content: '' !important;\n    position: absolute !important;\n    top: -2.5px !important;\n    bottom: -2.5px !important;\n    left: -2.5px !important;\n    right: -2.5px !important;\n    border-radius: 24px !important;\n    z-index: -1 !important;\n    pointer-events: none !important;\n    padding: 2.5px !important;\n    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0) !important;\n    -webkit-mask-composite: xor !important;\n    mask-composite: exclude !important;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n    opacity: 0.7 !important;\n    background: transparent !important;\n}\n\n/* Disable card background glows to avoid flooding colors inside */\n.dms-conn-card::after,\n.connection-card::after {\n    content: none !important;\n    display: none !important;\n}\n\n/* Default border gradients for cloud providers */\n.dms-conn-card.provider-gcp::before,\n.connection-card.provider-gcp::before {\n    background: linear-gradient(135deg, #06b6d4, #10b981) !important;\n}\n\n.dms-conn-card.provider-aws::before,\n.connection-card.provider-aws::before {\n    background: linear-gradient(135deg, #ef4444, #ec4899) !important;\n}\n\n.dms-conn-card.provider-azure::before,\n.connection-card.provider-azure::before {\n    background: linear-gradient(135deg, #8b5cf6, #6366f1) !important;\n}\n\n/* --- Tested States overrides matching Photos --- */\n\n/* Light Mode: tested state card surfaces and borders */\nhtml[data-theme=\"light\"] .dms-conn-card.success,\nhtml[data-theme=\"light\"] .connection-card.test-success {\n    background: rgba(240, 253, 250, 0.85) !important;\n    border: 2.5px solid rgba(16, 185, 129, 0.8) !important;\n    box-shadow: 0 10px 25px rgba(16, 185, 129, 0.05) !important;\n}\n\nhtml[data-theme=\"light\"] .dms-conn-card.failed,\nhtml[data-theme=\"light\"] .connection-card.test-failed {\n    background: rgba(254, 242, 242, 0.85) !important;\n    border: 2.5px solid rgba(239, 68, 68, 0.8) !important;\n    box-shadow: 0 10px 25px rgba(239, 68, 68, 0.05) !important;\n}\n\n/* Dark Mode: tested state card surfaces and solid borders */\nhtml[data-theme=\"dark\"] .dms-conn-card.success,\nhtml[data-theme=\"dark\"] .connection-card.test-success {\n    background: rgba(10, 15, 30, 0.9) !important;\n    border: 2.5px solid #10b981 !important;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.18), 0 0 15px rgba(16, 185, 129, 0.15) !important;\n}\n\nhtml[data-theme=\"dark\"] .dms-conn-card.failed,\nhtml[data-theme=\"dark\"] .connection-card.test-failed {\n    background: rgba(10, 15, 30, 0.9) !important;\n    border: 2.5px solid #ef4444 !important;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.18), 0 0 15px rgba(239, 68, 68, 0.12) !important;\n}\n\n/* Hover border illumination */\n.dms-conn-card:hover::before,\n.connection-card:hover::before {\n    opacity: 1.0 !important;\n}\n\n/* Provider Circular Logo containers */\n.provider-avatar-glass {\n    border-radius: 50% !important;\n    width: 48px !important;\n    height: 48px !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    transition: all 0.3s ease !important;\n}\n\nhtml[data-theme=\"dark\"] .provider-avatar-glass {\n    background: #0d1119 !important;\n    border: 1px solid rgba(255, 255, 255, 0.08) !important;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3) !important;\n}\n\nhtml[data-theme=\"light\"] .provider-avatar-glass {\n    background: #ffffff !important;\n    border: 1px solid rgba(0, 0, 0, 0.08) !important;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05) !important;\n}\n\n/* Role Destination/Source badges */\n.role-badge-pill {\n    border-radius: 6px !important;\n    font-size: 0.65rem !important;\n    font-weight: 700 !important;\n    padding: 0.2rem 0.6rem !important;\n    letter-spacing: 0.05em !important;\n}\n\n/* Source - Purple */\n.role-badge-pill.source {\n    background: rgba(139, 92, 246, 0.15) !important;\n    color: #c084fc !important;\n    border: 1px solid rgba(139, 92, 246, 0.3) !important;\n}\n\nhtml[data-theme=\"light\"] .role-badge-pill.source {\n    background: rgba(139, 92, 246, 0.1) !important;\n    color: #7c3aed !important;\n    border: 1px solid rgba(139, 92, 246, 0.2) !important;\n}\n\n/* Destination - Cyan */\n.role-badge-pill.destination {\n    background: rgba(14, 165, 233, 0.15) !important;\n    color: #38bdf8 !important;\n    border: 1px solid rgba(14, 165, 233, 0.3) !important;\n}\n\nhtml[data-theme=\"light\"] .role-badge-pill.destination {\n    background: rgba(14, 165, 233, 0.1) !important;\n    color: #0284c7 !important;\n    border: 1px solid rgba(14, 165, 233, 0.2) !important;\n}\n\n/* ASIA-SOUTH1 region badge */\n.region-pill-min {\n    background: rgba(255, 255, 255, 0.06) !important;\n    border: 1px solid rgba(255, 255, 255, 0.08) !important;\n    color: #cbd5e1 !important;\n    font-weight: 700 !important;\n    font-size: 0.6rem !important;\n    padding: 0.15rem 0.5rem !important;\n    border-radius: 4px !important;\n    letter-spacing: 0.04em !important;\n}\n\nhtml[data-theme=\"light\"] .region-pill-min {\n    background: rgba(0, 0, 0, 0.05) !important;\n    border: 1px solid rgba(0, 0, 0, 0.08) !important;\n    color: #4a5568 !important;\n}\n\n/* Glassy Inner Slates */\nhtml[data-theme='dark'] .inner-data-slate,\nhtml[data-theme='dark'] .connection-details {\n    background: #090c15 !important;\n    border: 1px solid rgba(255, 255, 255, 0.06) !important;\n    border-radius: 16px !important;\n    box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.35) !important;\n}\n\nhtml[data-theme='dark'] .slate-item-box,\nhtml[data-theme='dark'] .detail-row {\n    background: rgba(255, 255, 255, 0.03) !important;\n    border: 1px solid rgba(255, 255, 255, 0.05) !important;\n    border-radius: 12px !important;\n    box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.02) !important;\n}\n\nhtml[data-theme='dark'] .slate-item-box:hover {\n    background: rgba(255, 255, 255, 0.06) !important;\n    border-color: rgba(255, 255, 255, 0.08) !important;\n}\n\n/* Light Mode: Inner slates tinted by test state */\nhtml[data-theme='light'] .inner-data-slate,\nhtml[data-theme='light'] .connection-details {\n    background: rgba(0, 0, 0, 0.02) !important;\n    border: 1px solid rgba(0, 0, 0, 0.04) !important;\n    border-radius: 16px !important;\n    box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.02) !important;\n}\n\nhtml[data-theme='light'] .dms-conn-card.success .inner-data-slate,\nhtml[data-theme='light'] .connection-card.test-success .connection-details {\n    background: rgba(209, 250, 229, 0.5) !important;\n    border: 1px solid rgba(16, 185, 129, 0.15) !important;\n}\n\nhtml[data-theme='light'] .dms-conn-card.failed .inner-data-slate,\nhtml[data-theme='light'] .connection-card.test-failed .connection-details {\n    background: rgba(254, 226, 226, 0.6) !important;\n    border: 1px solid rgba(239, 68, 68, 0.15) !important;\n}\n\nhtml[data-theme='light'] .slate-item-box,\nhtml[data-theme='light'] .detail-row {\n    background: #ffffff !important;\n    border: 1px solid rgba(0, 0, 0, 0.06) !important;\n    border-radius: 12px !important;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02) !important;\n}\n\nhtml[data-theme='light'] .slate-item-box:hover {\n    background: #ffffff !important;\n    border-color: rgba(99, 102, 241, 0.25) !important;\n    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.04) !important;\n}\n\n/* Glass Buttons Base */\n.btn-sq-action,\n.btn-test,\n.btn-edit-small,\n.btn-delete-small {\n    background: rgba(255, 255, 255, 0.02) !important;\n    backdrop-filter: blur(8px) !important;\n    border-radius: 10px !important;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n    font-weight: 700 !important;\n    font-size: 0.68rem !important;\n    letter-spacing: 0.08em !important;\n    text-transform: uppercase !important;\n    box-shadow: none !important;\n}\n\n/* Light Mode Buttons */\nhtml[data-theme=\"light\"] .btn-sq-action.test,\nhtml[data-theme=\"light\"] .btn-test {\n    background: rgba(99, 102, 241, 0.04) !important;\n    border: 1px solid rgba(99, 102, 241, 0.35) !important;\n    color: #4f46e5 !important;\n}\n\nhtml[data-theme=\"light\"] .btn-sq-action.test:hover,\nhtml[data-theme=\"light\"] .btn-test:hover {\n    background: rgba(99, 102, 241, 0.1) !important;\n    border-color: #4f46e5 !important;\n    transform: translateY(-2px) !important;\n}\n\nhtml[data-theme=\"light\"] .btn-sq-action.edit,\nhtml[data-theme=\"light\"] .btn-edit-small {\n    background: rgba(139, 92, 246, 0.04) !important;\n    border: 1px solid rgba(139, 92, 246, 0.35) !important;\n    color: #7c3aed !important;\n}\n\nhtml[data-theme=\"light\"] .btn-sq-action.edit:hover,\nhtml[data-theme=\"light\"] .btn-edit-small:hover {\n    background: rgba(139, 92, 246, 0.1) !important;\n    border-color: #7c3aed !important;\n    transform: translateY(-2px) !important;\n}\n\nhtml[data-theme=\"light\"] .btn-sq-action.delete,\nhtml[data-theme=\"light\"] .btn-delete-small {\n    background: rgba(239, 68, 68, 0.03) !important;\n    border: 1px solid rgba(239, 68, 68, 0.35) !important;\n    color: #dc2626 !important;\n}\n\nhtml[data-theme=\"light\"] .btn-sq-action.delete:hover,\nhtml[data-theme=\"light\"] .btn-delete-small:hover {\n    background: rgba(239, 68, 68, 0.08) !important;\n    border-color: #dc2626 !important;\n    transform: translateY(-2px) !important;\n}\n\n/* Dark Mode Buttons (Match white text/purple border layout from photo) */\nhtml[data-theme=\"dark\"] .btn-sq-action.test,\nhtml[data-theme=\"dark\"] .btn-test {\n    background: rgba(99, 102, 241, 0.04) !important;\n    border: 1px solid rgba(99, 102, 241, 0.45) !important;\n    color: #ffffff !important;\n}\n\nhtml[data-theme=\"dark\"] .btn-sq-action.test:hover,\nhtml[data-theme=\"dark\"] .btn-test:hover {\n    background: rgba(99, 102, 241, 0.15) !important;\n    border-color: #818cf8 !important;\n    transform: translateY(-2px) !important;\n}\n\nhtml[data-theme=\"dark\"] .btn-sq-action.edit,\nhtml[data-theme=\"dark\"] .btn-edit-small {\n    background: rgba(139, 92, 246, 0.04) !important;\n    border: 1px solid rgba(139, 92, 246, 0.45) !important;\n    color: #ffffff !important;\n}\n\nhtml[data-theme=\"dark\"] .btn-sq-action.edit:hover,\nhtml[data-theme=\"dark\"] .btn-edit-small:hover {\n    background: rgba(139, 92, 246, 0.15) !important;\n    border-color: #a78bfa !important;\n    transform: translateY(-2px) !important;\n}\n\nhtml[data-theme=\"dark\"] .btn-sq-action.delete,\nhtml[data-theme=\"dark\"] .btn-delete-small {\n    background: rgba(239, 68, 68, 0.04) !important;\n    border: 1px solid rgba(239, 68, 68, 0.45) !important;\n    color: #fca5a5 !important;\n}\n\nhtml[data-theme=\"dark\"] .btn-sq-action.delete:hover,\nhtml[data-theme=\"dark\"] .btn-delete-small:hover {\n    background: rgba(239, 68, 68, 0.15) !important;\n    border-color: #fda4af !important;\n    transform: translateY(-2px) !important;\n}\n\n/* Badges - Outline-only glass pills */\n.status-badge-pill,\n.connectivity-label {\n    border-radius: 100px !important;\n    font-weight: 700 !important;\n    font-size: 0.65rem !important;\n    letter-spacing: 0.08em !important;\n    text-transform: uppercase !important;\n    padding: 0.25rem 0.65rem !important;\n    background: transparent !important;\n    box-shadow: none !important;\n}\n\n/* Light Mode Badges (Outline Only) */\nhtml[data-theme=\"light\"] .status-badge-pill.success {\n    border: 1.5px solid rgba(16, 185, 129, 0.6) !important;\n    color: #059669 !important;\n}\n\nhtml[data-theme=\"light\"] .status-badge-pill.failed {\n    border: 1.5px solid rgba(239, 68, 68, 0.5) !important;\n    color: #dc2626 !important;\n}\n\n/* Dark Mode Badges (Outline Only) */\nhtml[data-theme=\"dark\"] .status-badge-pill.success {\n    border: 1px solid rgba(16, 185, 129, 0.6) !important;\n    color: #34d399 !important;\n}\n\nhtml[data-theme=\"dark\"] .status-badge-pill.failed {\n    border: 1px solid rgba(239, 68, 68, 0.6) !important;\n    color: #fb7185 !important;\n}\n\n/* Neutral/Role tags & labels */\nhtml[data-theme=\"light\"] .connectivity-label {\n    background: transparent !important;\n    border: none !important;\n    color: #52526b !important;\n}\n\nhtml[data-theme=\"dark\"] .connectivity-label {\n    background: transparent !important;\n    border: none !important;\n    color: #cbd5e1 !important;\n}\n\n/* Typography readability and contrast overrides */\nhtml[data-theme=\"light\"] .primary-title-row h3 {\n    color: #090d16 !important;\n    font-weight: 700 !important;\n}\n\nhtml[data-theme=\"light\"] .subtitle-detail {\n    color: #52526b !important;\n    font-weight: 500 !important;\n}\n\nhtml[data-theme=\"light\"] .slate-label,\nhtml[data-theme=\"light\"] .detail-label {\n    color: #000 !important;\n    font-weight: 800 !important;\n}\n\nhtml[data-theme=\"light\"] .slate-value,\nhtml[data-theme=\"light\"] .detail-value {\n    color: #0f172a !important;\n    font-weight: 400 !important;\n}\n\nhtml[data-theme=\"light\"] .secure-text {\n    color: #059669 !important;\n    font-weight: 600 !important;\n}\n\nhtml[data-theme=\"dark\"] .primary-title-row h3 {\n    color: #ffffff !important;\n    font-weight: 700 !important;\n}\n\nhtml[data-theme=\"dark\"] .subtitle-detail {\n    color: #cbd5e1 !important;\n    font-weight: 500 !important;\n}\n\nhtml[data-theme=\"dark\"] .slate-label,\nhtml[data-theme=\"dark\"] .detail-label {\n    color: #e2e8f0 !important;\n    font-weight: 800 !important;\n}\n\nhtml[data-theme=\"dark\"] .slate-value,\nhtml[data-theme=\"dark\"] .detail-value {\n    color: #ffffff !important;\n    font-weight: 400 !important;\n}\n\n/* --- Draft Connection Card and Status Badge Styling --- */\nhtml[data-theme=\"light\"] .dms-conn-card.draft,\nhtml[data-theme=\"light\"] .connection-card.draft {\n    background: rgba(254, 243, 199, 0.75) !important;\n    border: 2.5px solid rgba(245, 158, 11, 0.8) !important;\n    box-shadow: 0 10px 25px rgba(245, 158, 11, 0.05) !important;\n}\n\nhtml[data-theme=\"dark\"] .dms-conn-card.draft,\nhtml[data-theme=\"dark\"] .connection-card.draft {\n    background: rgba(10, 15, 30, 0.9) !important;\n    border: 2.5px solid #fbbf24 !important;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.18), 0 0 15px rgba(245, 158, 11, 0.15) !important;\n}\n\nhtml[data-theme=\"light\"] .status-badge-pill.draft {\n    border: 1.5px solid rgba(245, 158, 11, 0.6) !important;\n    color: #d97706 !important;\n    background: transparent !important;\n}\n\nhtml[data-theme=\"dark\"] .status-badge-pill.draft {\n    border: 1px solid rgba(251, 191, 36, 0.6) !important;\n    color: #fbbf24 !important;\n    background: transparent !important;\n}\n\nhtml[data-theme='light'] .dms-conn-card.draft .inner-data-slate,\nhtml[data-theme='light'] .connection-card.draft .connection-details {\n    background: rgba(254, 243, 199, 0.4) !important;\n    border: 1px solid rgba(245, 158, 11, 0.15) !important;\n}\n\n/* ==========================================================================\n   TOOLBAR SECTION (Search, Filter, Sort)\n   ========================================================================== */\n\n.connections-toolbar-premium {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 0.75rem;\n    /* 12px gaps between controls */\n    margin-bottom: 2.5rem;\n    padding: 0.5rem 0.5rem;\n    width: 100%;\n}\n\n@media (max-width: 768px) {\n    .connections-toolbar-premium {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 1rem;\n    }\n\n    .view-switcher-premium {\n        width: 100%;\n    }\n\n    .btn-switcher-tab {\n        flex: 1;\n    }\n}\n\n/* --- Search Bar Glass Container --- */\n.search-bar-glass-container {\n    position: relative;\n    flex: 1;\n    display: flex;\n    align-items: center;\n    max-width: none;\n    background: var(--bg-input, rgba(10, 12, 24, 0.45));\n    backdrop-filter: blur(20px);\n    border: 1px solid var(--border-glass, rgba(255, 255, 255, 0.08));\n    border-radius: 12px;\n    padding: 0 0.85rem;\n    height: 42px;\n    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);\n    transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\nhtml[data-theme='light'] .search-bar-glass-container {\n    background: #ffffff;\n    border: 1px solid rgba(0, 0, 0, 0.08);\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.02), 0 4px 15px rgba(0, 0, 0, 0.02);\n}\n\n.search-icon-dim {\n    color: var(--text-muted);\n    margin-right: 0.75rem;\n    pointer-events: none;\n    transition: color 0.28s;\n}\n\ninput[type=\"text\"].search-input-glass {\n    flex: 1;\n    border: none !important;\n    background: transparent !important;\n    color: var(--text-primary) !important;\n    font-size: 0.9rem !important;\n    font-weight: 500 !important;\n    outline: none !important;\n    padding: 0 !important;\n    height: 100% !important;\n    box-shadow: none !important;\n    border-radius: 0 !important;\n}\n\n.search-input-glass::placeholder {\n    color: var(--text-muted);\n    opacity: 0.7;\n}\n\n.clear-search-btn {\n    border: none;\n    background: transparent;\n    color: var(--text-muted);\n    font-size: 1.2rem;\n    cursor: pointer;\n    padding: 0 4px;\n    transition: color 0.2s;\n    line-height: 1;\n    display: flex;\n    align-items: center;\n}\n\n.clear-search-btn:hover {\n    color: var(--text-primary);\n}\n\n/* Focus State: Soft Purple Glow */\n.search-bar-glass-container:focus-within {\n    border-color: rgba(168, 85, 247, 0.5) !important;\n    box-shadow: 0 0 0 1px rgba(168, 85, 247, 0.2), 0 0 15px rgba(168, 85, 247, 0.15), inset 0 1px 1px rgba(255, 255, 255, 0.05);\n}\n\nhtml[data-theme='light'] .search-bar-glass-container:focus-within {\n    border-color: rgba(168, 85, 247, 0.6) !important;\n    box-shadow: 0 0 0 1px rgba(168, 85, 247, 0.2), 0 0 12px rgba(168, 85, 247, 0.12);\n}\n\n/* --- Dropdown controls --- */\n.toolbar-actions-group {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n}\n\n@media (max-width: 768px) {\n    .toolbar-actions-group {\n        justify-content: flex-start;\n        width: 100%;\n    }\n\n    .toolbar-dropdown-container {\n        flex: 1;\n    }\n\n    .btn-toolbar-dropdown {\n        width: 100%;\n        justify-content: space-between;\n    }\n}\n\n.toolbar-dropdown-container {\n    position: relative;\n}\n\n.btn-toolbar-dropdown {\n    display: flex;\n    align-items: center;\n    gap: 0.6rem;\n    height: 42px;\n    padding: 0 1.1rem;\n    border-radius: 12px;\n    background: rgba(255, 255, 255, 0.03);\n    backdrop-filter: blur(16px);\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    color: var(--text-secondary);\n    font-size: 0.82rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);\n}\n\nhtml[data-theme='light'] .btn-toolbar-dropdown {\n    background: rgba(0, 0, 0, 0.01);\n    border: 1px solid rgba(0, 0, 0, 0.06);\n    color: #4b5563;\n}\n\n.btn-toolbar-dropdown:hover {\n    background: rgba(255, 255, 255, 0.06);\n    border-color: rgba(255, 255, 255, 0.12);\n    color: var(--text-primary);\n    transform: translateY(-1px);\n}\n\nhtml[data-theme='light'] .btn-toolbar-dropdown:hover {\n    background: rgba(0, 0, 0, 0.03);\n    border-color: rgba(0, 0, 0, 0.12);\n    color: #111827;\n}\n\n.btn-toolbar-dropdown.active-filter {\n    border-color: rgba(168, 85, 247, 0.4);\n    background: rgba(168, 85, 247, 0.05);\n    color: #a855f7;\n}\n\nhtml[data-theme='light'] .btn-toolbar-dropdown.active-filter {\n    border-color: rgba(168, 85, 247, 0.5);\n    background: rgba(168, 85, 247, 0.04);\n    color: #7e22ce;\n}\n\n.chevron-rotate {\n    transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.chevron-rotate.open {\n    transform: rotate(180deg);\n}\n\n/* Floating Glass Dropdown Panel */\n.dropdown-panel-glass {\n    position: absolute;\n    top: calc(100% + 6px);\n    right: 0;\n    width: 220px;\n    background: rgba(15, 23, 42, 0.85);\n    backdrop-filter: blur(24px) saturate(180%);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 14px;\n    padding: 0.4rem;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.05);\n    z-index: 1000;\n    \n    opacity: 0;\n    visibility: hidden;\n    pointer-events: none;\n    transform: translateY(-8px) scale(0.97);\n    transition: opacity 0.2s, visibility 0.2s, transform 0.2s;\n}\n\n.dropdown-panel-glass.open {\n    opacity: 1;\n    visibility: visible;\n    pointer-events: auto;\n    animation: slideDownFade 0.2s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\nhtml[data-theme='light'] .dropdown-panel-glass {\n    background: rgba(255, 255, 255, 0.95);\n    border: 1px solid rgba(0, 0, 0, 0.08);\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);\n}\n\n@keyframes slideDownFade {\n    from {\n        opacity: 0;\n        transform: translateY(-8px) scale(0.97);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0) scale(1);\n    }\n}\n\n.dropdown-panel-header {\n    font-size: 0.65rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: var(--text-muted);\n    padding: 0.4rem 0.75rem;\n    margin-bottom: 0.25rem;\n}\n\n.dropdown-panel-options {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.dropdown-option-btn {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding: 0.55rem 0.75rem;\n    border-radius: 8px;\n    border: none;\n    background: transparent;\n    color: var(--text-secondary);\n    font-size: 0.82rem;\n    font-weight: 550;\n    text-align: left;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\nhtml[data-theme='light'] .dropdown-option-btn {\n    color: #4b5563;\n}\n\n.dropdown-option-btn:hover {\n    background: rgba(255, 255, 255, 0.06);\n    color: var(--text-primary);\n}\n\nhtml[data-theme='light'] .dropdown-option-btn:hover {\n    background: rgba(0, 0, 0, 0.03);\n    color: #111827;\n}\n\n.dropdown-option-btn.selected {\n    background: rgba(99, 102, 241, 0.08);\n    color: #818cf8;\n}\n\nhtml[data-theme='light'] .dropdown-option-btn.selected {\n    background: rgba(99, 102, 241, 0.05);\n    color: #4f46e5;\n}\n\n.check-icon-purple {\n    color: #818cf8;\n}\n\nhtml[data-theme='light'] .check-icon-purple {\n    color: #4f46e5;\n}\n\n/* --- Empty state for search results --- */\n.no-search-results-glass {\n    grid-column: 1 / -1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 4rem 2rem;\n    background: rgba(255, 255, 255, 0.01);\n    backdrop-filter: blur(12px);\n    border: 1px dashed var(--border-color);\n    border-radius: 20px;\n    text-align: center;\n}\n\nhtml[data-theme='light'] .no-search-results-glass {\n    background: rgba(0, 0, 0, 0.005);\n}\n\n.no-results-icon {\n    color: var(--text-muted);\n    opacity: 0.4;\n    margin-bottom: 1rem;\n}\n\n.no-search-results-glass h3 {\n    margin: 0 0 0.5rem;\n    font-size: 1.2rem;\n    color: var(--text-primary);\n}\n\n.no-search-results-glass p {\n    margin: 0 0 1.5rem;\n    font-size: 0.88rem;\n    color: var(--text-muted);\n    max-width: 400px;\n}\n\n.btn-secondary-toolbar {\n    padding: 0.6rem 1.25rem;\n    background: rgba(255, 255, 255, 0.04);\n    border: 1px solid var(--border-color);\n    color: var(--text-primary);\n    font-size: 0.8rem;\n    font-weight: 600;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\nhtml[data-theme='light'] .btn-secondary-toolbar {\n    background: rgba(0, 0, 0, 0.01);\n}\n\n.btn-secondary-toolbar:hover {\n    background: rgba(255, 255, 255, 0.08);\n    transform: translateY(-1px);\n}\n\nhtml[data-theme='light'] .btn-secondary-toolbar:hover {\n    background: rgba(0, 0, 0, 0.03);\n}\n\n/* ==========================================================================\n   DRAFTS SECTION & DRAFT CARDS (Mini Glassmorphism Design)\n   ========================================================================== */\n\n.drafts-section-divider-container {\n    margin-top: 5rem;\n    padding-top: 3rem;\n    border-top: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n/* --- View Switcher Segmented Control --- */\n.view-switcher-premium {\n    display: flex;\n    align-items: center;\n    height: 42px;\n    background: rgba(255, 255, 255, 0.03);\n    backdrop-filter: blur(20px);\n    -webkit-backdrop-filter: blur(20px);\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    border-radius: 99px;\n    /* Rounded pill container */\n    padding: 3px;\n    gap: 2px;\n    box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.01), 0 4px 12px rgba(0, 0, 0, 0.05);\n    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\nhtml[data-theme='light'] .view-switcher-premium {\n    background: rgba(0, 0, 0, 0.015);\n    border-color: rgba(0, 0, 0, 0.06);\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.01), 0 2px 8px rgba(0, 0, 0, 0.02);\n}\n\n/* Subtle hover lift & shadow glow */\n.view-switcher-premium:hover {\n    transform: translateY(-1px);\n    border-color: rgba(168, 85, 247, 0.2);\n    box-shadow:\n        0 6px 20px rgba(0, 0, 0, 0.15),\n        0 0 10px rgba(168, 85, 247, 0.05),\n        inset 0 1px 1px rgba(255, 255, 255, 0.02);\n}\n\nhtml[data-theme='light'] .view-switcher-premium:hover {\n    border-color: rgba(124, 58, 237, 0.15);\n    box-shadow: 0 4px 12px rgba(124, 58, 237, 0.04);\n}\n\n.btn-switcher-tab {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    height: 100%;\n    padding: 0 1.5rem;\n    border-radius: 99px;\n    border: 1px solid transparent;\n    background: transparent;\n    color: var(--text-secondary);\n    font-size: 0.85rem;\n    font-weight: 600;\n    cursor: pointer;\n    opacity: 0.65;\n    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n    position: relative;\n    white-space: nowrap;\n}\n\n.btn-switcher-tab:hover {\n    opacity: 1;\n    color: var(--text-primary);\n    background: rgba(255, 255, 255, 0.03);\n}\n\nhtml[data-theme='light'] .btn-switcher-tab:hover {\n    background: rgba(0, 0, 0, 0.02);\n}\n\n/* Active Segment Highlight: glossy glassmorphism, LED border glow, elevated surface */\n.btn-switcher-tab.active {\n    opacity: 1;\n    color: #ffffff !important;\n    background: linear-gradient(135deg, rgba(168, 85, 247, 0.28) 0%, rgba(99, 102, 241, 0.24) 100%) !important;\n    border: 1px solid rgba(168, 85, 247, 0.6) !important;\n    box-shadow:\n        0 0 12px rgba(168, 85, 247, 0.35),\n        0 4px 10px rgba(0, 0, 0, 0.25),\n        inset 0 1px 0 rgba(255, 255, 255, 0.12) !important;\n}\n\nhtml[data-theme='light'] .btn-switcher-tab.active {\n    background: linear-gradient(135deg, rgba(124, 58, 237, 0.16) 0%, rgba(79, 70, 229, 0.16) 100%) !important;\n    color: #6d28d9 !important;\n    border: 1px solid rgba(124, 58, 237, 0.5) !important;\n    box-shadow:\n        0 0 10px rgba(124, 58, 237, 0.25),\n        0 4px 8px rgba(124, 58, 237, 0.1),\n        inset 0 1px 0 rgba(255, 255, 255, 0.2) !important;\n}\n\n/* Red/Green LED highlight when Drafts tab has drafts */\n.btn-switcher-tab.has-drafts::after {\n    content: '';\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: #10b981;\n    box-shadow: 0 0 8px #10b981;\n    display: inline-block;\n    margin-left: 2px;\n}\n\n/* Transition Blur effect for main grid switching */\n.dms-connections-grid {\n    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.dms-connections-grid.transition-blur {\n    opacity: 0;\n    filter: blur(8px);\n    transform: scale(0.98);\n}\n\n/* Configuration Progress Bar in Draft Cards */\n.draft-progress-container {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    margin: 0.8rem 0;\n    padding: 0.5rem 0.25rem 0;\n}\n\n.draft-progress-label-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 0.72rem;\n    font-weight: 600;\n}\n\n.draft-progress-text {\n    color: var(--text-muted);\n}\n\n.draft-progress-percent {\n    color: #a78bfa;\n}\n\nhtml[data-theme='light'] .draft-progress-percent {\n    color: #6d28d9;\n}\n\n.draft-progress-track {\n    height: 6px;\n    border-radius: 100px;\n    background: rgba(255, 255, 255, 0.04);\n    overflow: hidden;\n    position: relative;\n    border: 1px solid rgba(255, 255, 255, 0.02);\n}\n\nhtml[data-theme='light'] .draft-progress-track {\n    background: rgba(0, 0, 0, 0.04);\n    border-color: rgba(0, 0, 0, 0.02);\n}\n\n.draft-progress-fill {\n    height: 100%;\n    border-radius: 100px;\n    background: linear-gradient(90deg, #a78bfa, #818cf8);\n    transition: width 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\nhtml[data-theme='light'] .draft-progress-fill {\n    background: linear-gradient(90deg, #7c3aed, #4f46e5);\n}\n\n/* ── Draft Connection Card ── */\n.draft-conn-card {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    padding: 1.35rem;\n    border-radius: 24px;\n    background: rgba(15, 20, 35, 0.72);\n    border: 1.5px dashed rgba(255, 255, 255, 0.1);\n    backdrop-filter: blur(24px) saturate(160%);\n    -webkit-backdrop-filter: blur(24px) saturate(160%);\n    cursor: default;\n    transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);\n    opacity: 0;\n    animation: draftCardIn 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n    overflow: hidden;\n}\n\nhtml[data-theme='light'] .draft-conn-card {\n    background: rgba(248, 250, 255, 0.75);\n    border: 1.5px dashed rgba(0, 0, 0, 0.1);\n}\n\n@keyframes draftCardIn {\n    from {\n        opacity: 0;\n        transform: translateY(12px) scale(0.98);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0) scale(1);\n    }\n}\n\n/* Hover state */\n.draft-conn-card:hover {\n    transform: translateY(-3px);\n    border-color: rgba(168, 85, 247, 0.35);\n    background: rgba(20, 27, 50, 0.85);\n    box-shadow:\n        0 12px 32px rgba(0, 0, 0, 0.3),\n        0 0 0 1px rgba(168, 85, 247, 0.15),\n        inset 0 1px 0 rgba(255, 255, 255, 0.04);\n}\n\nhtml[data-theme='light'] .draft-conn-card:hover {\n    background: rgba(255, 255, 255, 0.92);\n    border-color: rgba(124, 58, 237, 0.3);\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.07), 0 0 0 1px rgba(124, 58, 237, 0.12);\n}\n\n/* Glossy top edge light sweep */\n.draft-conn-card::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 1px;\n    background: linear-gradient(90deg,\n            transparent 0%,\n            rgba(168, 85, 247, 0.4) 40%,\n            rgba(99, 179, 237, 0.3) 60%,\n            transparent 100%);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n}\n\n.draft-conn-card:hover::before {\n    opacity: 1;\n}\n\n/* Role-specific left glow */\n.draft-conn-card.role-source:hover {\n    box-shadow:\n        0 12px 32px rgba(0, 0, 0, 0.3),\n        -2px 0 14px rgba(168, 85, 247, 0.12),\n        0 0 0 1px rgba(168, 85, 247, 0.2);\n}\n\n.draft-conn-card.role-destination:hover {\n    box-shadow:\n        0 12px 32px rgba(0, 0, 0, 0.3),\n        -2px 0 14px rgba(56, 189, 248, 0.12),\n        0 0 0 1px rgba(56, 189, 248, 0.2);\n}\n\n/* ── Draft Badges ── */\n.draft-badges-group {\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n}\n\n.badge-auto-saved {\n    display: inline-flex;\n    align-items: center;\n    gap: 3px;\n    height: 18px;\n    padding: 0 7px;\n    border-radius: 100px;\n    background: rgba(251, 191, 36, 0.1);\n    border: 1px solid rgba(251, 191, 36, 0.3);\n    color: #fbbf24;\n    font-size: 0.6rem;\n    font-weight: 700;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n}\n\nhtml[data-theme='light'] .badge-auto-saved {\n    background: rgba(217, 119, 6, 0.08);\n    border-color: rgba(217, 119, 6, 0.3);\n    color: #b45309;\n}\n\n.badge-incomplete {\n    display: inline-flex;\n    align-items: center;\n    gap: 3px;\n    height: 18px;\n    padding: 0 7px;\n    border-radius: 100px;\n    background: rgba(239, 68, 68, 0.08);\n    border: 1px solid rgba(239, 68, 68, 0.25);\n    color: #f87171;\n    font-size: 0.6rem;\n    font-weight: 700;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n}\n\nhtml[data-theme='light'] .badge-incomplete {\n    background: rgba(220, 38, 38, 0.06);\n    border-color: rgba(220, 38, 38, 0.2);\n    color: #dc2626;\n}\n\n/* ── Draft avatar (dimmer than live connections) ── */\n.draft-avatar {\n    opacity: 0.7;\n}\n\n.draft-conn-card:hover .draft-avatar {\n    opacity: 1;\n}\n\n/* Draft status tag */\n.draft-status-tag {\n    display: inline-flex;\n    align-items: center;\n    height: 16px;\n    padding: 0 6px;\n    border-radius: 4px;\n    background: rgba(168, 85, 247, 0.1);\n    border: 1px solid rgba(168, 85, 247, 0.25);\n    color: #a78bfa;\n    font-size: 0.58rem;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n}\n\nhtml[data-theme='light'] .draft-status-tag {\n    background: rgba(124, 58, 237, 0.07);\n    border-color: rgba(124, 58, 237, 0.2);\n    color: #6d28d9;\n}\n\n/* Dimmed / empty slate values */\n.slate-empty {\n    color: var(--text-muted) !important;\n    font-style: italic;\n    opacity: 0.6;\n}\n\n/* Draft slate — slightly dimmer surface */\n.draft-slate {\n    opacity: 0.85;\n}\n\n.draft-conn-card:hover .draft-slate {\n    opacity: 1;\n}\n\n/* ── Draft card action buttons ── */\n.actions-row-strip.draft-actions {\n    margin-top: 1rem;\n    padding-top: 0.85rem;\n    border-top: 1px solid rgba(255, 255, 255, 0.04);\n}\n\nhtml[data-theme='light'] .actions-row-strip.draft-actions {\n    border-top: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.btn-sq-action.resume {\n    background: rgba(251, 191, 36, 0.06) !important;\n    border: 1px solid rgba(251, 191, 36, 0.3) !important;\n    color: #fbbf24 !important;\n}\n\n.btn-sq-action.resume:hover {\n    background: #fbbf24 !important;\n    border-color: #fbbf24 !important;\n    color: #0f172a !important;\n}\n\nhtml[data-theme='light'] .btn-sq-action.resume {\n    border-color: rgba(217, 119, 6, 0.3) !important;\n    background: rgba(217, 119, 6, 0.06) !important;\n    color: #b45309 !important;\n}\n\nhtml[data-theme='light'] .btn-sq-action.resume:hover {\n    background: #d97706 !important;\n    border-color: #d97706 !important;\n    color: #fff !important;\n}\n\n/* --- BULLETPROOF LIGHT MODE ACTION BUTTONS --- */\n\n/* TEST BUTTON */\nhtml[data-theme='light'] .btn-sq-action.test,\nhtml[data-theme='light'] .btn-sq-action.test:focus {\n    background: #e0e7ff !important;\n    color: #4f46e5 !important;\n    border-color: #a5b4fc !important;\n    box-shadow: none !important;\n}\n\nhtml[data-theme='light'] .btn-sq-action.test:hover,\nhtml[data-theme='light'] .btn-sq-action.test:active {\n    background: #c7d2fe !important;\n    border-color: #818cf8 !important;\n    color: #4338ca !important;\n    box-shadow: 0 2px 4px rgba(79, 70, 229, 0.1) !important;\n}\n\n/* EDIT BUTTON */\nhtml[data-theme='light'] .btn-sq-action.edit,\nhtml[data-theme='light'] .btn-sq-action.edit:focus {\n    background: #f3e8ff !important;\n    color: #7c3aed !important;\n    border-color: #d8b4fe !important;\n    box-shadow: none !important;\n}\n\nhtml[data-theme='light'] .btn-sq-action.edit:hover,\nhtml[data-theme='light'] .btn-sq-action.edit:active {\n    background: #e9d5ff !important;\n    border-color: #c084fc !important;\n    color: #6d28d9 !important;\n    box-shadow: 0 2px 4px rgba(124, 58, 237, 0.1) !important;\n}\n\n/* DELETE BUTTON */\nhtml[data-theme='light'] .btn-sq-action.delete,\nhtml[data-theme='light'] .btn-sq-action.delete:focus {\n    background: #fee2e2 !important;\n    color: #dc2626 !important;\n    border-color: #fca5a5 !important;\n    box-shadow: none !important;\n}\n\nhtml[data-theme='light'] .btn-sq-action.delete:hover,\nhtml[data-theme='light'] .btn-sq-action.delete:active {\n    background: #fecaca !important;\n    border-color: #f87171 !important;\n    color: #b91c1c !important;\n    box-shadow: 0 2px 4px rgba(220, 38, 38, 0.1) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
